import React, {
  useState,
  useEffect,
  createRef,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { Col } from "reactstrap";
import { Row } from "reactstrap";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import styles from "./../../../../Scheduler.module.scss";
import Text from "components/Text";
import { withTranslation } from "react-i18next";
import {
  encodeId,
  generateMonth,
  generateWeek,
  getStorage,
  isMobileTab,
  handleError,
} from "utils";
import * as moment from "moment";
import {
  useGetOfficeAgenda,
  useGetEventListForAssignerByEmployee,
  duplicateSchedulerEvent,
  useCreateUpdateSchedulerEventMutation,
  getEventListDetails,
  getSchedularNotes,
  deleteSchedularNote,
} from "repositories/scheduler-repository";
import { buildDuplicateSchedulerEventPayload } from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventShiftsView/duplicateSchedulerEvent.utils";
import { useMultipleDuplicatesFlyout } from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventShiftsView/useMultipleDuplicatesFlyout";
import { useAssignUsersFromCard } from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventShiftsView/useAssignUsersFromCard";
import { useSimpleEventCardDelete } from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventShiftsView/useSimpleEventCardDelete";
import { useQuickEditFromCard } from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventShiftsView/useQuickEditFromCard";
import QuickEditModal from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventShiftsView/QuickEditModal";
import {
  buildUnassignedEventsFromAssignerByEmployee,
  serializeSchedulerHistoryDate,
  canDragSchedulerEventWithUnassigned,
  isUnassignedSchedulerEvent,
  canDropEventToUnassignedSection,
} from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventShiftsView/unassignedEvents.utils";
import {
  filterEventsWorkspaceBySearch,
  countSchedulerEventOccurrences,
} from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventShiftsView/eventsWorkspacePublish.utils";
import { UnassignedEventsStaffRow } from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventShiftsView/UnassignedEventsSection";
import { NoteView } from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventShiftsView/EventsShiftsMonthly";
import EmptySchedulerCellAdd from "accountOwner/pages/Scheduler/components/EmptySchedulerCellAdd";
import AddNotesModal from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/Modals/AddNotesModal";
import EditNotesModal from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/Modals/EditNotesModal";
import DeleteNotes from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/Modals/DeleteNotes";
import {
  validateStaffCellDropAssignment,
  validateShiftListingStaffDrop,
  resolveEventAssignmentOffice,
  resolveShiftStaffChangeOfficeId,
  resolveDraggedSourceEmployee,
  resolveEventOrShiftOffice,
  schedulerEmployeeOfficeKey,
} from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventShiftsView/dragDropAssignment.utils";
import SelectOfficeForUserModal from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventShiftsView/SelectOfficeForUserModal";
import { getOfficesByOwnerAndUser } from "repositories/office-repository";
import { cloneDeep, findKey } from "lodash";
import constants from "../../../../../../../constants.js";
import { useHistory } from "react-router-dom";
import defautUserImage from "assets/images/staff-default-rounded.png";
import Loader from "components/Loader";
import toast from "react-hot-toast";
import HolidayImage from "assets/images/early_on.svg";
import crossIcon from "assets/images/cross.svg";
import CallIcon from "assets/images/call-icon.svg";
import Empty from "components/Empty";
import {
  MoreTagsFunction,
  renderOfficeNameOrEnterprise,
  setterCustomSchduler,
  setterPublishOffices,
  matchedBothPatternValues,
  matchedBothDatesValues,
} from "accountOwner/pages/AddEvent/addEvents.functions";
import { addEditEventsConst } from "accountOwner/pages/AddEvent/addEvents.constants";
import EditOptionsModal, {
  editTypesVariables,
} from "accountOwner/pages/EditEvent/EditOptionsModal";
import InviteesPopup from "accountOwner/pages/EventDetails/components/Modals/InviteesPopup";
import {
  addAllItemsTypes,
  filterEventsBySearch,
  filteringMethodForEventShiftOthers,
  highlightClassWhenEventWillExist,
  leaveClasses,
  mapAssignerByEmployeeToOfficeAgenda,
  compareStaffByWeeklySortOption,
  canShowEventCardMenu,
  resolveDragDropTargetOfficeId,
  normalizeSchedulerOfficeId,
} from "accountOwner/pages/Scheduler/scheduler.function";
import { useParams } from "react-router-dom";
import { calculateMaxVisibleElements } from "..";
import { ThreeDots } from "react-bootstrap-icons";
import {
  getEventShiftSelectionKey,
  isEventShiftSelected,
} from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventShiftsView/eventWeeklyLayout.constants";
import { leaveScreenEnabled } from "./MonthlyViewNew";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import { useQueryClient } from "react-query";

function StaffAvailabilityWeeklyView({
  t,
  currentDate,
  selectedOwnerId,
  currentUserId,
  apiOffices,
  apiEmps,
  isSidebarActive,
  isWeekly,
  agendaTypes,
  cachedEventFilter,
  viewSettingFilter,
  isFromDashBoard,
  context = "default",
  selectedStaff,
  searchValue = "",
  isEnterpriseFilterActive = false,
  isFreeStotLoading,
  onDateChange,
  disabledDates,
  isfromLeaveDetailScreen,
  isFromLeaveDetail,
  canShowOfficeName,
  eventsWorkspaceMode = false,
  eventShiftFilter = [],
  appliedPublishedDraftFilter = [],
  bulkSelectMode = false,
  selectedEventKeys = {},
  onEventSelectionToggle,
  onSelectableEventsUpdate,
  onVisibleDraftEventsUpdate,
  onVisibleClearableItemsUpdate,
  sortStaffBy,
  isBulkActionLoading = false,
  upDateListonApply,
  settotalEvents,
  canAddShift = false,
}) {
  const {
    profile,
    isStaff,
    isOwner,
    dataAccessValues,
    effectiveOwnerIdString,
  } = useAccountOwnerCommon();
  const isSchedulingAssistant = context === "scheduling-assistant";

  const canEditAndViewOthersData = useCallback(
    (officeId) => {
      if (isStaff) {
        return (
          dataAccessValues?.officeList?.some(
            (res) => res.officeId === officeId && res.isAdmin,
          ) || false
        );
      }
      return isOwner;
    },
    [isStaff, isOwner, dataAccessValues?.officeList],
  );
  const history = useHistory();
  const calendarRef = createRef(null);
  const { eventId: eventIdFromUrl } = useParams();
  const displaySettingNotApplied = !viewSettingFilter?.length;
  const [weekData, setWeekData] = useState([]);
  const [monthData, setMonthData] = useState([]);
  const [seeMoreUsers, setSeeMoreUsers] = useState([]);
  const [seeMoreOnCalender, setSeeMoreOnCalender] = useState("");
  const [seeMoreMax, setSeeMoreMax] = useState({});
  const cellRef = useRef([]);
  const [hoverKey, setHoverKey] = useState("");
  const [hoverBusySlotKey, setHoverBusySlotKey] = useState("");
  const [agenda, setAgenda] = useState(null);
  const [agendaFilter, setAgendaFilter] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const [nonInvitePopup, setNonInvitePopup] = useState(false);
  const [draggedEvent, setDraggedEvent] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [dragPreviewCell, setDragPreviewCell] = useState(null);
  const [isDragDropLoading, setIsDragDropLoading] = useState(false);
  const [isDuplicateLoading, setIsDuplicateLoading] = useState(false);
  const [pendingDragUpdate, setPendingDragUpdate] = useState(null);
  const [editModalConfirmation, setEditModalConfirmation] = useState(false);
  const [pendingOfficeDrop, setPendingOfficeDrop] = useState(null);
  const [isOfficeSelectModalOpen, setIsOfficeSelectModalOpen] = useState(false);
  const [invitePopupPosition, setInvitePopupPosition] = useState({
    top: 0,
    right: 0,
  });
  const [dayNotesByDate, setDayNotesByDate] = useState({});
  const [activeNoteDateKey, setActiveNoteDateKey] = useState("");
  const [isNotesLoading, setIsNotesLoading] = useState(false);
  const [isAddNotesModal, setIsAddNotesModal] = useState({
    visible: false,
    date: "",
    value: "",
  });
  const [isEditNotesModal, setIsEditNotesModal] = useState({ visible: false });
  const [deleteConfirmation, setdeleteConfirmation] = useState({
    visible: false,
    id: "",
  });

  // ADDED: New state and ref for dynamic height logic
  const [tableHeight, setTableHeight] = useState(
    isFromDashBoard ? "390px" : "auto",
  );
  const scrollContainerRef = useRef(null);
  const draggedEventDateRef = useRef(null);

  const {
    openEventMenuKey,
    closeEventMenuAndFlyout,
    createEventMenuToggleHandler,
    handleMultipleDuplicatesClick,
    renderMultipleDuplicatesFlyout,
  } = useMultipleDuplicatesFlyout({
    scrollContainerRef,
    menuStyles: styles,
  });

  const createSchedulerEventMutation = useCreateUpdateSchedulerEventMutation();
  const queryClient = useQueryClient();

  // ADDED: Logic for dynamic height adjustment
  useEffect(() => {
    if (isFromDashBoard) {
      setTableHeight("390px");
      return;
    }

    const calculateDynamicHeight = () => {
      if (scrollContainerRef.current) {
        // Get the distance of the container from the top of the viewport
        const rect = scrollContainerRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // Find the specific wrapper based on client instructions:
        // Look for .scheduler-tabs or .Dashboard_box to check boundaries.
        // Fallback to document.body if neither is found.
        const wrapper =
          scrollContainerRef.current.closest(".scheduler-tabs") ||
          scrollContainerRef.current.closest(".Dashboard_box") ||
          document.body;

        // Default limit is the bottom of the viewport
        let limitBottom = viewportHeight;

        // If the wrapper is found, check if its bottom is visible within the viewport
        if (wrapper) {
          const wrapperRect = wrapper.getBoundingClientRect();
          // If the wrapper's bottom is ABOVE the viewport bottom (meaning we scrolled past it or it's short),
          // use the wrapper's bottom as the limit. This prevents overlap.
          // We subtract a small buffer (5px) to ensure borders aren't cut off.
          if (wrapperRect.bottom < viewportHeight) {
            limitBottom = wrapperRect.bottom - 5;
          }
        }

        // Calculate maxHeight: The distance from the top of the table (rect.top)
        // to the limit (either screen bottom or wrapper bottom).
        // We subtract 20px for the scrollbar itself so it sits comfortably.
        let computedHeight = limitBottom - rect.top - 20;

        // Minimum safety check to prevent it from disappearing
        if (computedHeight < 200) computedHeight = 200;

        setTableHeight(`${computedHeight}px`);
      }
    };

    // Calculate on mount and shortly after (for DOM paint)
    calculateDynamicHeight();
    const timeoutId = setTimeout(calculateDynamicHeight, 100);

    // Attach listeners
    window.addEventListener("resize", calculateDynamicHeight);
    window.addEventListener("scroll", calculateDynamicHeight, {
      passive: true,
    });

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", calculateDynamicHeight);
      window.removeEventListener("scroll", calculateDynamicHeight);
    };
  }, [isFromDashBoard, agenda]);

  const handlePopupToggle1 = (event, setter, hoverbusykey = "") => {
    event.stopPropagation();
    setHoverBusySlotKey(hoverbusykey);
    setHoverKey("");
    setInvitePopupPosition({
      top: 95,
      right: 0,
    });
    setter((prev) => !prev);
  };

  const handlePopupToggle = (userId) => {
    setPopupOpen((prev) => (prev === userId ? null : userId));
  };

  const filterByEvents = (agendaData) => {
    const updatedAgenda = agendaData?.map((item) => {
      const schedulerList = Array.isArray(item.officeSchedulerList)
        ? item.officeSchedulerList
        : [item.officeSchedulerList];

      const filteredSchedulerList = schedulerList.map((schedulerItem) =>
        filteringMethodForEventShiftOthers(
          agendaTypes,
          schedulerItem,
          currentUserId,
        ),
      );

      return {
        ...item,
        officeSchedulerList: filteredSchedulerList,
      };
    });
    return updatedAgenda;
  };

  const filterEventWorkspaceSchedulerEvents = (events = []) => {
    let filtered = [...(events || [])];

    if (eventShiftFilter?.length) {
      const eventsFilter = eventShiftFilter.includes("event");
      const shiftFilter = eventShiftFilter.includes("shift");
      const shiftByOtherFilter = eventShiftFilter.includes("shift-others");
      filtered = filtered.filter((ev) => {
        if (eventsFilter && !ev.isShift) return true;
        if (
          shiftFilter &&
          ev.isShift &&
          (shiftByOtherFilter || ev.createdById === currentUserId)
        ) {
          return true;
        }
        if (
          shiftByOtherFilter &&
          ev.isShift &&
          ev.createdById !== currentUserId
        ) {
          return true;
        }
        return false;
      });
    }

    if (appliedPublishedDraftFilter?.length) {
      filtered = filtered.filter((ev) => {
        if (appliedPublishedDraftFilter.includes("published") && !ev.isDraft) {
          return true;
        }
        if (appliedPublishedDraftFilter.includes("draft") && ev.isDraft) {
          return true;
        }
        return false;
      });
    }

    if (isEnterpriseFilterActive) {
      filtered = filtered.filter((e) => e?.isEnterprise === true);
    }

    return filtered;
  };

  const filterByEventWorkspace = (agendaData) => {
    return agendaData?.map((dateItem) => {
      const schedulerList = Array.isArray(dateItem.officeSchedulerList)
        ? dateItem.officeSchedulerList
        : [dateItem.officeSchedulerList];

      const filteredSchedulerList = schedulerList.map((schedulerItem) => ({
        ...schedulerItem,
        schedulerEvents: filterEventWorkspaceSchedulerEvents(
          schedulerItem?.schedulerEvents,
        ),
        appointments: [],
        appointmentSlots: [],
        leaves: [],
        schedulerBusySlots: [],
      }));

      return {
        ...dateItem,
        officeSchedulerList: filteredSchedulerList,
      };
    });
  };

  // Filter agenda to only include staff selected in the employee filter (events workspace)
  const filterAgendaByApiEmps = (agenda) => {
    if (!Array.isArray(apiEmps) || apiEmps.length === 0) {
      return agenda;
    }

    const selectedIdSet = new Set(apiEmps.map((id) => String(id)));
    return (agenda || []).map((dateObj) => ({
      ...dateObj,
      officeSchedulerList: (dateObj.officeSchedulerList || []).filter((item) =>
        selectedIdSet.has(String(item.user?.id)),
      ),
    }));
  };

  // Filter agenda to only include selectedStaff in scheduling-assistant context
  const filterAgendaBySelectedStaff = (agenda) => {
    if (
      isSchedulingAssistant &&
      Array.isArray(selectedStaff) &&
      selectedStaff.length > 0
    ) {
      // selectedStaff can be array of staff objects or ids, match by id
      const selectedIds = selectedStaff
        .map((s) => s.user?.id || s.id || s.userId)
        .filter(Boolean);
      let filteredAgenda = (agenda || []).map((dateObj) => {
        // Filter officeSchedulerList for each date
        const filteredOfficeSchedulerList = (
          dateObj.officeSchedulerList || []
        ).filter((item) => selectedIds.includes(item.user?.id));
        return {
          ...dateObj,
          officeSchedulerList: filteredOfficeSchedulerList,
        };
      });

      return agendaTypes.length > 0
        ? filterByEvents(filteredAgenda)
        : filteredAgenda;
    }

    return agenda;
  };

  useEffect(() => {
    if (isSchedulingAssistant) {
      setAgendaFilter(filterAgendaBySelectedStaff(agenda));
    } else if (eventsWorkspaceMode) {
      setAgendaFilter(filterAgendaByApiEmps(filterByEventWorkspace(agenda)));
    } else {
      if (cachedEventFilter?.length > 0) {
        setAgendaFilter(filterByEvents(agenda));
      } else if (cachedEventFilter?.length === 0) {
        setAgendaFilter(agenda);
      }
    }
  }, [
    JSON.stringify(agenda),
    JSON.stringify(cachedEventFilter),
    JSON.stringify(selectedStaff),
    JSON.stringify(apiEmps),
    JSON.stringify(eventShiftFilter),
    JSON.stringify(appliedPublishedDraftFilter),
    isEnterpriseFilterActive,
    eventsWorkspaceMode,
    context,
  ]);

  useEffect(() => {
    if (isWeekly) {
      getWeeksDates(currentDate);
    } else {
      getMonthDates(currentDate);
    }
    if (isMobileTab() && isSidebarActive) {
      toast.success(t("accountOwner.dateApply"));
    }
    //eslint-disable-next-line
  }, [currentDate, isWeekly]);

  const getWeeksDates = (_currentDate) => {
    const selectedStartWeek = moment(_currentDate).startOf("week");
    const selectedEndWeek = moment(_currentDate).endOf("week");
    const currentweekData = generateWeek(selectedStartWeek, selectedEndWeek);
    setWeekData(currentweekData);
  };

  const getMonthDates = (_currentDate) => {
    const monthDates = generateMonth(_currentDate);
    setMonthData(monthDates);
  };

  const queryDateRange = useMemo(() => {
    if (!currentDate) return null;
    if (isWeekly) {
      const start = moment(currentDate).startOf("week");
      const end = moment(currentDate).endOf("week");
      return {
        startDate: start.format("YYYY-MM-DD"),
        endDate: end.format("YYYY-MM-DD"),
      };
    }
    const monthDates = generateMonth(currentDate);
    if (!monthDates?.length) return null;
    return {
      startDate: moment(monthDates[0].date).format("YYYY-MM-DD"),
      endDate: moment(monthDates[monthDates.length - 1].date).format(
        "YYYY-MM-DD",
      ),
    };
  }, [currentDate, isWeekly]);

  const enableFetch = Boolean(
    selectedOwnerId && queryDateRange?.startDate && queryDateRange?.endDate,
  );

  const fetchDayNotes = useCallback(async () => {
    if (
      !eventsWorkspaceMode ||
      !selectedOwnerId ||
      !queryDateRange?.startDate ||
      !queryDateRange?.endDate
    ) {
      return;
    }
    try {
      const response = await getSchedularNotes(
        queryDateRange.startDate,
        queryDateRange.endDate,
        selectedOwnerId,
      );
      const notesMap = {};
      (response?.data || []).forEach((note) => {
        const key = moment(note.date).format("YYYY-MM-DD");
        notesMap[key] = note;
      });
      setDayNotesByDate(notesMap);
    } catch (error) {
      handleError(error);
    }
  }, [
    eventsWorkspaceMode,
    selectedOwnerId,
    queryDateRange?.startDate,
    queryDateRange?.endDate,
  ]);

  useEffect(() => {
    if (!eventsWorkspaceMode || !enableFetch) {
      setDayNotesByDate({});
      return;
    }
    fetchDayNotes();
  }, [eventsWorkspaceMode, enableFetch, fetchDayNotes, upDateListonApply]);

  const addNotesModelShow = useCallback((data, type) => {
    setIsAddNotesModal({
      visible: true,
      data,
      type,
      value: type === "EDIT" ? data?.data?.text : "",
    });
  }, []);

  const editNotesModelShow = useCallback((data) => {
    setIsEditNotesModal({ visible: true, data });
  }, []);

  const updateDayNoteList = useCallback(
    (data, type) => {
      if (!activeNoteDateKey) return;
      setDayNotesByDate((prev) => {
        const next = { ...prev };
        if (data && (type === "ADD" || type === "EDIT")) {
          next[activeNoteDateKey] = data.data;
        }
        if (type === "DELETE") {
          delete next[activeNoteDateKey];
        }
        return next;
      });
    },
    [activeNoteDateKey],
  );

  const deleteNotesConfirm = useCallback(() => {
    setdeleteConfirmation({ visible: false, id: "" });
    setIsNotesLoading(true);
    deleteSchedularNote(deleteConfirmation.id)
      .then((res) => {
        if (res.statusCode === 200) {
          updateDayNoteList("", "DELETE");
          toast.success(res?.message);
        }
        setIsNotesLoading(false);
      })
      .catch((e) => {
        setIsNotesLoading(false);
        toast.error(e.message);
      });
  }, [deleteConfirmation.id, updateDayNoteList]);

  const officeAgendaQuery = useGetOfficeAgenda(
    selectedOwnerId,
    queryDateRange?.startDate,
    queryDateRange?.endDate,
    isSchedulingAssistant ? [] : apiOffices,
    isSchedulingAssistant ? [] : apiEmps,
    { enabled: enableFetch && !eventsWorkspaceMode },
  );

  const assignerByEmployeeQuery = useGetEventListForAssignerByEmployee(
    selectedOwnerId,
    queryDateRange?.startDate,
    queryDateRange?.endDate,
    apiOffices,
    apiEmps,
    { enabled: enableFetch && eventsWorkspaceMode },
  );

  const {
    isLoading,
    isFetching,
    data: weeklyData,
    error,
    refetch: refetchOfficeAgenda,
  } = eventsWorkspaceMode ? assignerByEmployeeQuery : officeAgendaQuery;

  const refreshAfterAssignUsers = useCallback(async () => {
    queryClient.invalidateQueries(["office_agenda"]);
    queryClient.invalidateQueries(["event_list_assigner_by_employee"]);
    await refetchOfficeAgenda?.();
  }, [queryClient, refetchOfficeAgenda]);

  const { isAssignLoading, openAssignUsersModal, renderAssignUsersModals } =
    useAssignUsersFromCard({
      t,
      ownerId: selectedOwnerId,
      canAddShift,
      isStaff,
      onSuccess: refreshAfterAssignUsers,
    });

  const {
    isQuickEditOpen,
    isQuickEditSaving,
    quickEditContext,
    openQuickEdit,
    closeQuickEdit,
    saveQuickEdit,
  } = useQuickEditFromCard({
    t,
    ownerId: selectedOwnerId || currentUserId,
    onSuccess: refreshAfterAssignUsers,
  });

  const onDuplicateEvent = async (event, requestedDate, count = 1) => {
    try {
      setIsDuplicateLoading(true);
      await duplicateSchedulerEvent(
        buildDuplicateSchedulerEventPayload({
          schedulerEventId: event?.id,
          eventDate: requestedDate,
          duplicateCount: count,
          isStaffView: eventsWorkspaceMode,
          // Unassigned shifts/events must send UserId: null (not 0)
          userId: isUnassignedSchedulerEvent(event) ? null : event?.userId,
        }),
      );
      toast.success(t("scheduler.duplicateSuccess"));
      closeEventMenuAndFlyout();
      refetchOfficeAgenda();
    } catch (error) {
      toast.error(error?.message || t("CustomErrorMsg"));
    } finally {
      setIsDuplicateLoading(false);
    }
  };

  const { handleCardDeleteClick, renderSimpleDeleteConfirmModal } =
    useSimpleEventCardDelete({
      t,
      history,
      effectiveOwnerIdString,
      onSuccess: () => refetchOfficeAgenda(),
    });

  useEffect(() => {
    if (!isLoading && weeklyData?.data) {
      const isFromLeaveDetail = getStorage("IsFromLeaveSchedule");
      const loggedInUserId = currentUserId ?? profile?.id;
      const values = eventsWorkspaceMode
        ? mapAssignerByEmployeeToOfficeAgenda(weeklyData.data, {
            startDate: queryDateRange?.startDate,
            endDate: queryDateRange?.endDate,
            currentUserId: loggedInUserId,
            allowedUserIds: apiEmps,
          })
        : weeklyData.data;
      if (isFromLeaveDetail?.userID) {
        const data = values?.map((intial) => {
          const check = intial?.officeSchedulerList?.findIndex(
            (res) => res?.user?.id === isFromLeaveDetail?.userID,
          );
          if (check !== -1) {
            const insert = { ...intial?.officeSchedulerList[check] };
            intial?.officeSchedulerList?.splice(check, 1);
            intial?.officeSchedulerList?.unshift(insert);
          }
          return {
            ...intial,
          };
        });
        setAgenda(data);
        setAgendaFilter(data);
      } else {
        setAgenda(values);
        setAgendaFilter(values);
      }
    }
  }, [
    isLoading,
    weeklyData,
    eventsWorkspaceMode,
    queryDateRange?.startDate,
    queryDateRange?.endDate,
    currentUserId,
    profile?.id,
    apiEmps,
  ]);

  useEffect(() => {
    if (!isLoading && !isFetching && error?.message) {
      toast.error(error.message);
    }
    //eslint-disable-next-line
  }, [error]);

  const skipInitialFilterRefetchRef = useRef(false);
  useEffect(() => {
    if (!eventsWorkspaceMode || !enableFetch) return;
    if (!skipInitialFilterRefetchRef.current) {
      skipInitialFilterRefetchRef.current = true;
      return;
    }
    refetchOfficeAgenda();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [upDateListonApply, eventsWorkspaceMode, enableFetch]);
  let tableDates;
  if (isWeekly) {
    tableDates = weekData.map((v, i, allData) => {
      const cellDate = new Date(v?.date);
      const isPastDate = moment(cellDate).isBefore(moment(), "day");
      const dateKey = moment(v?.date).format("YYYY-MM-DD");
      const dayNote = dayNotesByDate[dateKey];
      const noteList = dayNote
        ? { note: true, data: dayNote, date: cellDate, id: dayNote?.id }
        : { note: false, date: cellDate };
      const headerClassHighlight = highlightClassWhenEventWillExist({
        cellDate,
        allData,
        i,
        disabledDates,
        styles,
      });
      return (
        <th
          key={i}
          className={`${styles.custom_th} p-0 ${
            isPastDate || !isSchedulingAssistant ? "" : "clickable-date"
          }`}
          onClick={() =>
            isSchedulingAssistant && !isPastDate && handleDateClick(cellDate)
          }
          style={{
            cursor:
              isSchedulingAssistant && !isPastDate
                ? "pointer"
                : isSchedulingAssistant && isPastDate
                  ? "not-allowed"
                  : "default",
            // Only dim past dates in scheduling assistant; events workspace
            // menus must stay full-opacity so options match other views.
            opacity: isSchedulingAssistant && isPastDate ? 0.7 : 1,
            minWidth: "133px",
          }}
        >
          <div
            className={`${styles.weekly_agenda_header} ${
              eventsWorkspaceMode ? styles["events-workspace-date-header"] : ""
            } ${
              headerClassHighlight
                ? headerClassHighlight + " " + styles.bottom
                : ""
            }`}
          >
            {eventsWorkspaceMode && dayNote && (
              <div className={styles["note-wrapper"]}>
                <NoteView
                  list={noteList}
                  dateShow={moment(v?.date).format("ddd, MMM DD")}
                />
              </div>
            )}
            <span className={styles["date-text"]}>{v.mDate}</span>
            {eventsWorkspaceMode && (
              <UncontrolledDropdown
                className={`select-common-dropdown ${styles["date-ellipse-menu"]}`}
                onClick={(e) => e.stopPropagation()}
              >
                <DropdownToggle tag="div" className="cursor-pointer">
                  <ThreeDots color="#9CA3AF" />
                </DropdownToggle>
                <DropdownMenu end>
                  <DropdownItem
                    onClick={() =>
                      history.push(constants.routes.scheduler.addEvent, {
                        date: dateKey,
                      })
                    }
                  >
                    <span>
                      {t(
                        canAddShift
                          ? "accountOwner.newEventShift"
                          : "accountOwner.newEvent",
                      )}
                    </span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      setActiveNoteDateKey(dateKey);
                      if (dayNote) {
                        editNotesModelShow(noteList);
                      } else {
                        addNotesModelShow(noteList, "ADD");
                      }
                    }}
                  >
                    <span>
                      {dayNote
                        ? t("accountOwner.viewNote")
                        : t("staff.addNote")}
                    </span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
          </div>
        </th>
      );
    });
  } else {
    tableDates = monthData.map((v, i) => {
      const cellDate = new Date(v.date);
      const isPastDate = moment(cellDate).isBefore(moment(), "day");

      return (
        <th
          key={i}
          className={isPastDate ? "" : "clickable-date"}
          onClick={() => !isPastDate && handleDateClick(cellDate)}
          style={{
            cursor: isPastDate ? "not-allowed" : "pointer",
            opacity: isPastDate ? 0.7 : 1,
          }}
        >
          {v.mDate}
        </th>
      );
    });
  }

  const resetHoverKey = (e) => {
    e.stopPropagation();
    setHoverKey("");
  };
  const getPopupData = (item, requestedDate) => {
    const data = {};
    data.title = item?.title || item?.reasonForBlock || null;
    data.officeName = renderOfficeNameOrEnterprise(item, t);
    data.patientFullName = item?.patientFullName || null;
    data.startTime =
      item?.startTime && moment(item.startTime).isValid()
        ? moment(item.startTime).format("h:mm a")
        : null;
    data.endTime =
      item?.endTime && moment(item.endTime).isValid()
        ? moment(item.endTime).format("h:mm a")
        : null;
    data.date = moment(requestedDate).format("MMM D, YYYY [-] ddd");
    const { agendaType } = item;
    switch (agendaType) {
      case constants.agendaType.EVENT: {
        const createdByOthers =
          item?.isShift && profile?.id !== item?.createdById;
        if (createdByOthers) {
          data.tag = t("scheduler.agenda.shiftByOthers");
        } else if (item?.isShift) {
          data.tag = t("scheduler.agenda.shiftTag");
        } else {
          data.tag = t("scheduler.agenda.eventTag");
        }
        break;
      }
      case constants.agendaType.BUSY_SLOT: {
        data.tag = t("scheduler.agenda.busyTag");
        break;
      }
      case constants.agendaType.BLOCKED: {
        data.tag = t("scheduler.agenda.busyTag");
        break;
      }
      case constants.agendaType.APPOINTMENT: {
        data.tag = t("scheduler.agenda.appointmentTag");
        data.title = t("scheduler.agenda.patient", {
          name: item.patientFullName,
        });
        data.isAppointment = true;
        const status = findKey(
          constants.appointmentStatus,
          (s) => s === item.appointmentStatus,
        );
        data.appointmentStatus = status
          ? t(`appointmentStatus.${status}`)
          : "--";
        break;
      }
      case constants.agendaType.LEAVE: {
        const { text } = leaveClasses(item?.statusId);
        data.tag = t(text);
        data.title = "";
        data.isLeave = true;
        break;
      }
      default: {
        break;
      }
    }
    return data;
  };
  const popUpRef = useRef(null);

  const getPopupView = (
    item,
    backgroudColor,
    tagBackgroundColor,
    requestedDate,
    staffName,
  ) => {
    const data = getPopupData(item, requestedDate);

    return (
      <div className={styles["scheduler-popup-box"]} ref={popUpRef}>
        <span className={styles["close-icon"]} onClick={resetHoverKey}>
          &times;
        </span>
        <div
          className={
            styles["scheduler-event-box"] + " " + styles[backgroudColor]
          }
        >
          <div
            className={styles["event-tag"] + " " + styles[tagBackgroundColor]}
          >
            {data.tag}
          </div>
          <div className={styles["event-type"]}>{data.title}</div>
          <Row className={styles.row}>
            <Col sm="6">
              <Text size="10px" marginBottom="0px" weight="400" color="#87928D">
                {constants.agendaType.APPOINTMENT === item.agendaType
                  ? t("scheduler.agenda.doctorName")
                  : t("scheduler.agenda.staffName")}
              </Text>
              <Text
                size="12px"
                marginBottom="10px"
                weight="500"
                color="#2F3245"
              >
                {staffName}
              </Text>
            </Col>
            <Col sm="6">
              <Text size="10px" marginBottom="0px" weight="400" color="#87928D">
                {t("accountOwner.officeName")}
              </Text>
              <Text
                size="12px"
                marginBottom="10px"
                weight="500"
                color="#2F3245"
              >
                {data.officeName}
              </Text>
            </Col>
            <Col sm="6">
              <Text size="10px" marginBottom="0px" weight="400" color="#87928D">
                {t("accountOwner.date")}
              </Text>
              <Text
                size="12px"
                marginBottom="10px"
                weight="500"
                color="#2F3245"
              >
                {data.date}
              </Text>
            </Col>
            {!data.isLeave && (data.startTime || data.isAppointment) && (
              <Col sm="6">
                <Text
                  size="10px"
                  marginBottom="0px"
                  weight="400"
                  color="#87928D"
                >
                  {data.isAppointment
                    ? t("timeOfAppointment")
                    : t("staff.startTime")}
                </Text>
                <Text
                  size="12px"
                  marginBottom="12px"
                  weight="500"
                  color="#2F3245"
                >
                  {data.startTime}
                </Text>
              </Col>
            )}
            {!data.isLeave && (data.endTime || data.isAppointment) && (
              <Col sm="6">
                <Text
                  size="10px"
                  marginBottom="0px"
                  weight="400"
                  color="#87928D"
                >
                  {data.isAppointment ? t("status") : t("staff.endTime")}
                </Text>
                <Text
                  size="12px"
                  marginBottom="12px"
                  weight="500"
                  color="#2F3245"
                >
                  {data.isAppointment ? data?.appointmentStatus : data.endTime}
                </Text>
              </Col>
            )}
          </Row>
        </div>
      </div>
    );
  };
  const goToDetails = (id, type, createdByMe, requestedDate) => {
    if (!id || !type) return;

    const normalizedRequestedDate =
      serializeSchedulerHistoryDate(requestedDate);
    const normalizedCurrentDate = serializeSchedulerHistoryDate(currentDate);

    const locationStateSending = {
      requestedDate: normalizedRequestedDate,
      fromScreen: isSchedulingAssistant
        ? "schedulingAssistant"
        : "staffSchedule",
      schedulingAssistantState: {
        selectedStaff,
        currentDate: normalizedCurrentDate,
      },
      eventId: eventIdFromUrl,
    };
    switch (type) {
      case constants.agendaType.EVENT: {
        let pathname = "/";
        pathname = createdByMe
          ? constants.routes.scheduler.eventDetails.replace(
              ":eventId",
              encodeId(id),
            )
          : constants.routes.scheduler.eventDetailsOnly.replace(
              ":eventId",
              encodeId(id),
            );
        history.replace({
          state: locationStateSending,
          search: window.location.search,
        });
        history.push({
          pathname,
          state: locationStateSending,
          search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
        });
        break;
      }
      case constants.agendaType.BUSY_SLOT: {
        const pathname = constants.routes.scheduler.busySlotDetail.replace(
          ":busySlotId",
          encodeId(id),
        );
        history.replace({
          state: locationStateSending,
          search: window.location.search,
        });
        history.push({
          pathname,
          state: locationStateSending,
          search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
        });
        break;
      }
      default: {
        return;
      }
    }
  };

  /**
   * Opens Create Event/Shift with the cell's date.
   * Staff is not preselected: the empty-cell payload is incomplete and
   * publishing an All Day event with it returns 500.
   */
  const openCreateEventFromEmptyCell = useCallback(
    ({ requestedDate } = {}) => {
      if (!eventsWorkspaceMode || bulkSelectMode || isDragging) return;

      const dateKey = requestedDate
        ? moment(requestedDate).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");

      history.push(constants.routes.scheduler.addEvent, {
        date: dateKey,
      });
    },
    [eventsWorkspaceMode, bulkSelectMode, isDragging, history],
  );

  const getUsefulInfo = (item) => {
    const id = item?.id;
    const officeName = renderOfficeNameOrEnterprise(item, t);
    let title = item?.title || item?.reasonForBlock || null;
    title =
      title && title.length > constants.agendaTitleLength
        ? title.slice(0, constants.agendaTitleLength).concat(" ...")
        : title;
    const timezoneCode = item?.timezoneCode || null;
    const isAllDayEvent = item?.isAllDayEvent;
    const timeString = item?.isAllDayEvent
      ? t("scheduler.agenda.allDayEvent")
      : item?.startTime && item?.endTime
        ? moment(item.startTime).format("h:mm A") +
          " - " +
          moment(item.endTime).format("h:mm A")
        : "";
    //sepecific to Schedular events
    const createdByMe = item.createdById === currentUserId;
    const isInvite = !!item.eventEmployeeStatus;
    const status = item.eventStatus;
    const location = item?.location;
    let backgroudColorClass;
    backgroudColorClass =
      status === constants.SCHEDULERSTATUS.PENDING
        ? "color-blue"
        : createdByMe
          ? ""
          : "color-grey";
    return {
      officeName,
      title,
      timezoneCode,
      timeString,
      id,
      isAllDayEvent,
      createdByMe,
      isInvite,
      status,
      backgroudColorClass,
      location,
    };
  };

  const canDragEvent = useCallback(
    (eventItem) => {
      if (!eventsWorkspaceMode || !eventItem) return false;

      const baseCanDrag = (item) => {
        const createdByMe = item.createdById === currentUserId;
        if (item?.isShift) {
          if (createdByMe) return true;
          if (isOwner) return true;
          if (isStaff && canEditAndViewOthersData(item?.officeId)) return true;
          return false;
        }
        if (
          item.agendaType === constants.agendaType.EVENT ||
          !item.agendaType
        ) {
          return createdByMe;
        }
        return false;
      };

      return canDragSchedulerEventWithUnassigned(eventItem, baseCanDrag);
    },
    [
      eventsWorkspaceMode,
      currentUserId,
      isOwner,
      isStaff,
      canEditAndViewOthersData,
    ],
  );

  const getTimeCheck = useCallback((alreadyTime, selectedTime) => {
    if (alreadyTime) {
      const selectedStartTime = moment(selectedTime);
      const alreadySelectedStartTime = moment(alreadyTime);
      return (
        selectedStartTime.hour() !== alreadySelectedStartTime.hour() ||
        selectedStartTime.minute() !== alreadySelectedStartTime.minute()
      );
    }
    return true;
  }, []);

  const buildDateTimeForDrop = useCallback((eventData, targetDate) => {
    const target = moment(targetDate);
    if (
      eventData.isAllDayEvent ||
      eventData.isAllDayBusy ||
      !eventData.startTime ||
      !eventData.endTime
    ) {
      return {
        newDate: target.startOf("day").toDate(),
        newStartTimeString: target
          .clone()
          .startOf("day")
          .format("YYYY-MM-DDTHH:mm"),
        newEndTimeString: target
          .clone()
          .endOf("day")
          .format("YYYY-MM-DDTHH:mm"),
      };
    }
    const originalStart = moment(eventData.startTime);
    const originalEnd = moment(eventData.endTime);
    const durationMinutes = Math.max(
      0,
      originalEnd.diff(originalStart, "minutes"),
    );
    const newStart = target
      .clone()
      .hour(originalStart.hour())
      .minute(originalStart.minute())
      .second(0);
    const newEnd = newStart.clone().add(durationMinutes, "minutes");
    return {
      newDate: target.startOf("day").toDate(),
      newStartTimeString: newStart.format("YYYY-MM-DDTHH:mm"),
      newEndTimeString: newEnd.format("YYYY-MM-DDTHH:mm"),
    };
  }, []);

  const employeeOfficeKey = (employee) =>
    `${employee?.userId ?? employee?.user?.id ?? ""}:${employee?.officeId ?? ""}`;

  /**
   * Builds employee roster + UpdateFlags for drag-drop, mirroring Edit Event verifyIfUpdated.
   * @param {object} eventData
   * @param {{ sourceUserId?: number|string, targetUserId?: number|string, targetOfficeId?: number|string }} dropContext
   */
  const computeDragDropEmployeeUpdate = (eventData, dropContext) => {
    const sourceUserId = dropContext?.sourceUserId;
    const targetUserId = dropContext?.targetUserId;
    const ownerOfficeList = (dataAccessValues?.officeList || []).map(
      (office) => ({
        id: office?.officeId ?? office?.id,
        name: office?.officeName ?? office?.name,
      }),
    );

    const originalActive = (eventData?.eventEmployees || []).filter(
      (employee) => !employee?.isDeletedForThisSchedulerEvent,
    );

    const isUnassignedToStaffAssignment =
      Boolean(targetUserId) &&
      !originalActive.length &&
      (Boolean(dropContext?.isUnassignedSource) ||
        isUnassignedSchedulerEvent(eventData));

    const isMovingToUnassigned = Boolean(dropContext?.isMovingToUnassigned);

    const hasStaffChange = Boolean(
      isMovingToUnassigned ||
      isUnassignedToStaffAssignment ||
      (sourceUserId &&
        targetUserId &&
        String(sourceUserId) !== String(targetUserId)),
    );

    const targetOfficeId = resolveDragDropTargetOfficeId({
      dropContext,
      eventData,
      originalActiveEmployees: originalActive,
      sourceUserId,
      apiOfficeIds: apiOffices,
    });

    if (isMovingToUnassigned) {
      const draggedUserId = sourceUserId;
      const sourceEmployee = resolveDraggedSourceEmployee(
        eventData?.eventEmployees,
        dropContext,
      );
      const sourceEmployeeKey = sourceEmployee
        ? schedulerEmployeeOfficeKey(sourceEmployee)
        : null;
      const removedEmployeeRowIds =
        sourceEmployee?.id != null && sourceEmployee.id !== 0
          ? [sourceEmployee.id]
          : [];
      const remainingEmployees = originalActive
        .filter((employee) =>
          sourceEmployeeKey
            ? schedulerEmployeeOfficeKey(employee) !== sourceEmployeeKey
            : String(employee?.userId ?? employee?.user?.id) !==
              String(draggedUserId),
        )
        .map((employee) => ({
          ...employee,
          id: employee?.id,
          schedulerEventId: employee?.schedulerEventId,
          userId: employee?.userId ?? employee?.user?.id,
          officeId:
            normalizeSchedulerOfficeId(employee?.officeId) ??
            employee?.officeId,
          IsDeleted: false,
          isDeleted: false,
        }));

      return {
        hasStaffChange: true,
        eventEmployeesPayload: remainingEmployees,
        employeesRosterOrRemovalChanged: true,
        updateFlags: {
          EmployeeIds:
            draggedUserId != null && draggedUserId !== ""
              ? [draggedUserId]
              : [],
          RemovedEmployeeRowIds: removedEmployeeRowIds,
          IsShiftOfficeChange: false,
        },
      };
    }

    if (isUnassignedToStaffAssignment) {
      const { officeId: sourceEventOfficeId } = resolveEventOrShiftOffice({
        eventData,
        dropContext,
        ownerOfficeList,
      });
      const resolvedOfficeId =
        normalizeSchedulerOfficeId(dropContext?.targetOfficeId) ??
        targetOfficeId ??
        sourceEventOfficeId;

      const activeCurrentEmployees = [
        {
          id: 0,
          schedulerEventId: eventData?.id,
          userId: targetUserId,
          officeId: resolvedOfficeId,
          IsDeleted: false,
          isDeleted: false,
        },
      ];

      return {
        hasStaffChange: true,
        eventEmployeesPayload: activeCurrentEmployees,
        employeesRosterOrRemovalChanged: true,
        updateFlags: {
          EmployeeIds: [targetUserId],
          RemovedEmployeeRowIds: [],
          IsShiftOfficeChange: false,
        },
      };
    }

    let userIds = originalActive.map((employee) => ({
      ...employee,
      id: employee?.id,
      schedulerEventId: employee?.schedulerEventId,
      userId: employee?.userId ?? employee?.user?.id,
      officeId:
        normalizeSchedulerOfficeId(employee?.officeId) ?? employee?.officeId,
      IsDeleted: false,
      isDeleted: false,
    }));

    let removedSourceEmployeeRowId = null;
    if (hasStaffChange) {
      const draggedSourceEmployee = resolveDraggedSourceEmployee(
        eventData?.eventEmployees,
        dropContext,
      );
      const draggedSourceEmployeeKey = draggedSourceEmployee
        ? schedulerEmployeeOfficeKey(draggedSourceEmployee)
        : null;
      if (draggedSourceEmployee?.id != null && draggedSourceEmployee.id !== 0) {
        removedSourceEmployeeRowId = draggedSourceEmployee.id;
      }

      userIds = userIds.filter((employee) =>
        draggedSourceEmployeeKey
          ? schedulerEmployeeOfficeKey(employee) !== draggedSourceEmployeeKey
          : String(employee.userId) !== String(sourceUserId),
      );
      const template =
        draggedSourceEmployee ||
        originalActive.find(
          (employee) =>
            String(employee?.userId ?? employee?.user?.id) ===
            String(sourceUserId),
        ) ||
        originalActive[0] ||
        {};
      const resolvedOfficeId = eventData?.isShift
        ? resolveShiftStaffChangeOfficeId(
            eventData,
            dropContext,
            sourceUserId,
            originalActive,
            ownerOfficeList,
          )
        : (targetOfficeId ??
          normalizeSchedulerOfficeId(template?.officeId) ??
          null);
      const targetKey = employeeOfficeKey({
        userId: targetUserId,
        officeId: resolvedOfficeId,
      });
      const hasTarget = userIds.some(
        (employee) => employeeOfficeKey(employee) === targetKey,
      );
      if (!hasTarget) {
        userIds.push({
          ...template,
          id: 0,
          schedulerEventId: template?.schedulerEventId ?? eventData?.id,
          userId: targetUserId,
          officeId: resolvedOfficeId,
          IsDeleted: false,
          isDeleted: false,
        });
      }
    }

    const originalActiveKeys = new Set(
      originalActive.map((employee) => schedulerEmployeeOfficeKey(employee)),
    );
    const fallbackOfficeId =
      eventData?.isShift && hasStaffChange
        ? resolveShiftStaffChangeOfficeId(
            eventData,
            dropContext,
            sourceUserId,
            originalActive,
            ownerOfficeList,
          )
        : (targetOfficeId ??
          normalizeSchedulerOfficeId(originalActive[0]?.officeId) ??
          normalizeSchedulerOfficeId(eventData?.officeId));
    const activeCurrentEmployees = userIds
      .filter((employee) => !(employee?.isDeleted || employee?.IsDeleted))
      .map((employee) => ({
        ...employee,
        officeId:
          normalizeSchedulerOfficeId(employee?.officeId) ?? fallbackOfficeId,
      }));
    const currentActiveKeys = new Set(
      activeCurrentEmployees.map((employee) =>
        schedulerEmployeeOfficeKey(employee),
      ),
    );

    const removedEmployeeRowIdsFromReplacedRows = originalActive
      .filter((employee) => {
        const key = schedulerEmployeeOfficeKey(employee);
        return (
          !currentActiveKeys.has(key) &&
          employee?.id != null &&
          employee.id !== 0
        );
      })
      .map((employee) => employee.id);

    const removedEmployeeRowIdsFromMarked = userIds.reduce((acc, employee) => {
      const isDeleted = employee?.isDeleted || employee?.IsDeleted;
      const rowId = employee?.id;
      if (isDeleted && rowId != null && rowId !== 0) {
        acc.push(rowId);
      }
      return acc;
    }, []);

    const removedEmployeeRowIds = [
      ...new Set([
        ...removedEmployeeRowIdsFromMarked,
        ...removedEmployeeRowIdsFromReplacedRows,
        ...(removedSourceEmployeeRowId != null
          ? [removedSourceEmployeeRowId]
          : []),
      ]),
    ];

    const employeesRosterChanged =
      originalActiveKeys.size !== currentActiveKeys.size ||
      [...currentActiveKeys].some((key) => !originalActiveKeys.has(key)) ||
      [...originalActiveKeys].some((key) => !currentActiveKeys.has(key));
    const employeesRosterOrRemovalChanged =
      removedEmployeeRowIds.length > 0 || employeesRosterChanged;

    const touchedEmployeeUserIds = new Set();
    activeCurrentEmployees.forEach((employee) => {
      const key = schedulerEmployeeOfficeKey(employee);
      if (!originalActiveKeys.has(key) && employee?.userId != null) {
        touchedEmployeeUserIds.add(employee.userId);
      }
    });
    originalActive.forEach((employee) => {
      const key = schedulerEmployeeOfficeKey(employee);
      const userId = employee?.userId ?? employee?.user?.id;
      if (!currentActiveKeys.has(key) && userId != null) {
        touchedEmployeeUserIds.add(userId);
      }
    });

    let isShiftOfficeChange = false;
    if (eventData?.isShift) {
      const origOfficeByUserId = new Map();
      originalActive.forEach((employee) => {
        const userId = employee?.userId ?? employee?.user?.id;
        if (userId != null) {
          origOfficeByUserId.set(userId, employee.officeId);
        }
      });
      const currOfficeByUserId = new Map();
      activeCurrentEmployees.forEach((employee) => {
        if (employee?.userId != null) {
          currOfficeByUserId.set(employee.userId, employee.officeId);
        }
      });
      for (const [userId, officeId] of currOfficeByUserId) {
        if (
          origOfficeByUserId.has(userId) &&
          origOfficeByUserId.get(userId) !== officeId
        ) {
          isShiftOfficeChange = true;
          break;
        }
      }

      // Single-assignee reassignment to another office also changes the shift office.
      if (!isShiftOfficeChange && hasStaffChange) {
        const originalShiftOffice =
          normalizeSchedulerOfficeId(eventData?.officeId) ??
          normalizeSchedulerOfficeId(originalActive[0]?.officeId);
        const newShiftOffice = normalizeSchedulerOfficeId(
          activeCurrentEmployees[0]?.officeId,
        );
        if (
          originalShiftOffice &&
          newShiftOffice &&
          originalShiftOffice !== newShiftOffice
        ) {
          isShiftOfficeChange = true;
        }
      }
    }

    return {
      hasStaffChange,
      eventEmployeesPayload: activeCurrentEmployees,
      employeesRosterOrRemovalChanged,
      updateFlags: {
        EmployeeIds: employeesRosterOrRemovalChanged
          ? [...touchedEmployeeUserIds]
          : [],
        RemovedEmployeeRowIds: removedEmployeeRowIds,
        IsShiftOfficeChange: isShiftOfficeChange,
      },
    };
  };

  const showEventAlreadyExistsForUserError = useCallback(
    (isShift) => {
      toast.error(
        t("scheduler.eventShiftAlreadyExistForUser", {
          eventOrShift: isShift
            ? t("accountOwner.shiftTab").toLowerCase()
            : t("accountOwner.eventTab").toLowerCase(),
        }),
      );
    },
    [t],
  );

  const performEventUpdate = useCallback(
    async (
      eventData,
      newDateTime,
      dropContext,
      editType,
      originalRequestedDate = null,
    ) => {
      if (!newDateTime || !eventData) {
        toast.error(t("scheduler.invalidEventData"));
        return;
      }

      const requestedDateForCheck = originalRequestedDate
        ? originalRequestedDate
        : eventData.requestedDate
          ? moment(eventData.requestedDate).format("YYYY-MM-DD")
          : eventData.startTime
            ? moment(eventData.startTime).format("YYYY-MM-DD")
            : moment(eventData.date || newDateTime.newDate).format(
                "YYYY-MM-DD",
              );

      const dateChangedResult = matchedBothDatesValues({
        eventDetail: eventData,
        repeatedEndDate: eventData.repeatedEndDate
          ? moment(eventData.repeatedEndDate).toDate()
          : moment().add(3, "month").toDate(),
        requestedDate: requestedDateForCheck,
        eventDate: newDateTime.newDate,
      });

      const startTimeChanged = getTimeCheck(
        eventData.startTime,
        newDateTime.newStartTimeString,
      );
      const endTimeChanged = getTimeCheck(
        eventData.endTime,
        newDateTime.newEndTimeString,
      );
      const { eventEmployeesPayload, updateFlags: employeeUpdateFlags } =
        computeDragDropEmployeeUpdate(eventData, dropContext);
      const isMovingToUnassigned = Boolean(dropContext?.isMovingToUnassigned);

      if (
        employeeUpdateFlags.EmployeeIds?.length > 0 &&
        eventEmployeesPayload.some(
          (employee) => !normalizeSchedulerOfficeId(employee?.officeId),
        )
      ) {
        toast.error(t("scheduler.invalidEventData"));
        return;
      }

      const originalRequestedDateForParams = originalRequestedDate
        ? moment(originalRequestedDate).format("YYYY-MM-DDTHH:mm")
        : eventData.requestedDate
          ? moment(eventData.requestedDate).format("YYYY-MM-DDTHH:mm")
          : eventData.startTime
            ? moment(eventData.startTime).format("YYYY-MM-DDTHH:mm")
            : moment(newDateTime.newDate).format("YYYY-MM-DDTHH:mm");

      const requestedDateForDateCalc = originalRequestedDate
        ? moment(originalRequestedDate).toDate()
        : eventData.requestedDate
          ? moment(eventData.requestedDate).toDate()
          : eventData.startTime
            ? moment(eventData.startTime).toDate()
            : null;

      const eventDate = moment(newDateTime.newDate).toDate();

      const params = {
        SchedulerEventId: eventData.id,
        OwnerId: selectedOwnerId || currentUserId,
        Title: eventData.title,
        Date: moment(
          requestedDateForDateCalc &&
            moment(requestedDateForDateCalc)
              .startOf("day")
              .isSame(moment(eventDate).startOf("day"))
            ? eventData?.date
            : eventDate,
        ).format("YYYY-MM-DDTHH:mm"),
        StartTime: newDateTime.newStartTimeString,
        EndTime: newDateTime.newEndTimeString,
        IsAllDayEvent: eventData.isAllDayEvent || false,
        RepeatedType: eventData.repeatedType || 1,
        RepeatedDay: moment(newDateTime.newDate).isoWeekday(),
        RepeatedEndDate:
          eventData.repeatedType > 1 && eventData.repeatedEndDate
            ? moment(eventData.repeatedEndDate).format("YYYY-MM-DD")
            : null,
        Location: eventData.location || "",
        BlockForPatient: eventData.blockForPatient || false,
        Note: eventData.note || "",
        PublishAsEvent: eventData.publishAsEvent || false,
        eventEmployees: eventEmployeesPayload,
        EventRoles: Array.isArray(eventData.eventRoles)
          ? eventData.eventRoles
          : [],
        EventTags: Array.isArray(eventData.eventTags)
          ? eventData.eventTags
          : [],
        CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
        ReminderBeforeInMins: eventData.reminderBeforeInMins || 0,
        isDraft: eventData.isDraft || false,
        requestedDate: originalRequestedDateForParams,
        timezoneCode: eventData.timezoneCode || moment.tz.guess(),
        EditType: editType || editTypesVariables.allEvent,
        ...(isMovingToUnassigned ? { IsUnassigned: true } : {}),
        UpdateFlags: {
          isTitleEdit: false,
          isStartTimeEdit: startTimeChanged,
          isEndTimeEdit: endTimeChanged,
          isAllDayEventEdit: false,
          isNoteEdit: false,
          isLocationEdit: false,
          isReminderBeforeInMinsEdit: false,
          isEnterpriseEdit: false,
          isOfficeIdEdit: false,
          EmployeeIds: employeeUpdateFlags.EmployeeIds,
          RemovedEmployeeRowIds: employeeUpdateFlags.RemovedEmployeeRowIds,
          IsShiftOfficeChange: employeeUpdateFlags.IsShiftOfficeChange,
          RoleIds: [],
          IsRepeatTypeChange: false,
          IsEventDateChange: dateChangedResult.startDateChanged,
          IsRepeatedEndDateChange: dateChangedResult.endDateChanged,
          IsBlockForPatientChange: false,
          tagsIds: false,
        },
      };

      if (eventData.isShift) {
        params.Title = eventData.title || "";
        delete params.Location;
        delete params.Note;
        const shiftOfficeId =
          normalizeSchedulerOfficeId(eventEmployeesPayload?.[0]?.officeId) ??
          normalizeSchedulerOfficeId(dropContext?.sourceOfficeId) ??
          normalizeSchedulerOfficeId(eventData?.officeId);
        if (shiftOfficeId) {
          params.officeId = shiftOfficeId;
        }
      } else {
        params.IsAutoApprove = eventData.isAutoApprove || false;
        if (dropContext?.makeEnterprise) {
          params.IsEnterprise = true;
          params.UpdateFlags.isEnterpriseEdit = true;
        }
      }

      try {
        setterCustomSchduler({
          params,
          repeatedType: eventData.repeatedType || 1,
          repeatedTypeFrequency: eventData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: eventData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedSlotDate:
            eventData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||
            [],
          selectedWeek: eventData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedMonths:
            eventData.customRepeatPattern?.monthsOfYear?.map((m) => m?.month) ||
            [],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: eventData,
        });
      } catch (error) {
        console.warn("Error in setterCustomSchduler:", error);
      }

      try {
        const preferredOption = {
          dropdown: eventData.publishAsEvent
            ? [{ id: "allowInvitees" }]
            : eventData.isDraft
              ? [{ id: "saveDraft" }]
              : [{ id: "inviteesOnly" }],
          otherOptions: [],
        };
        setterPublishOffices({
          preferredOption,
          userIds: eventEmployeesPayload,
          publishAsEvent: eventData.publishAsEvent
            ? "allowInvitees"
            : eventData.isDraft
              ? "saveDraft"
              : "inviteesOnly",
          nonInviteesPublish: eventData.publishedType || "allOffices",
          params,
          officeIdForNonInvitee: Array.isArray(
            eventData.schedulerEventPublishedOffices,
          )
            ? eventData.schedulerEventPublishedOffices.filter(
                (office) => office && office.id,
              )
            : [],
          edit: true,
          isDraft: eventData.isDraft || false,
        });
      } catch (error) {
        console.warn("Error in setterPublishOffices:", error);
      }

      await createSchedulerEventMutation.mutateAsync(params);
      queryClient.invalidateQueries(["office_agenda"]);
      queryClient.invalidateQueries(["event_list_assigner_by_employee"]);
      refetchOfficeAgenda();
      toast.success(t("staff.eventUpdated"));
    },
    [
      selectedOwnerId,
      currentUserId,
      createSchedulerEventMutation,
      t,
      queryClient,
      getTimeCheck,
      refetchOfficeAgenda,
    ],
  );

  const updateEventAfterDrag = useCallback(
    async (eventItem, dropContext, editType = null, options = {}) => {
      if (!eventItem?.id || !dropContext?.targetDate) {
        toast.error(t("scheduler.invalidEventData"));
        return { pendingOfficeModal: false };
      }
      try {
        const originalRequestedDate = draggedEventDateRef.current
          ? draggedEventDateRef.current
          : moment(eventItem.requestedDate || eventItem.startTime).format(
              "YYYY-MM-DD",
            );
        const eventDetails = await getEventListDetails(
          eventItem.id,
          originalRequestedDate,
        );
        const eventData = eventDetails?.data;
        if (!eventData) {
          toast.error(t("scheduler.eventNotFound"));
          return { pendingOfficeModal: false };
        }

        const dropContextWithSource = {
          ...dropContext,
          sourceUserId:
            dropContext.sourceUserId ?? draggedEvent?.sourceContext?.userId,
          sourceOfficeId:
            dropContext.sourceOfficeId ??
            draggedEvent?.sourceContext?.officeId ??
            draggedEvent?.eventItem?.officeId ??
            draggedEvent?.eventItem?.office?.id ??
            draggedEvent?.eventItem?.office?.officeId,
          sourceOfficeName:
            dropContext.sourceOfficeName ??
            draggedEvent?.sourceContext?.officeName ??
            draggedEvent?.eventItem?.officeName ??
            draggedEvent?.eventItem?.eventEmployeeOfficeName ??
            draggedEvent?.eventItem?.officeNameList ??
            draggedEvent?.eventItem?.office?.name ??
            draggedEvent?.eventItem?.office?.officeName,
          isShift:
            dropContext.isShift ?? Boolean(draggedEvent?.eventItem?.isShift),
        };

        const targetUserId = dropContextWithSource.targetUserId;
        const sourceUserId = dropContextWithSource.sourceUserId;
        const isSameUserMove =
          sourceUserId &&
          targetUserId &&
          String(sourceUserId) === String(targetUserId);

        if (
          eventsWorkspaceMode &&
          !options?.skipValidation &&
          !dropContext.isMovingToUnassigned &&
          !isSameUserMove
        ) {
          const validation = validateStaffCellDropAssignment({
            eventData,
            dropContext: dropContextWithSource,
            sourceContext: draggedEvent?.sourceContext || {},
            ownerOfficeList: (dataAccessValues?.officeList || []).map(
              (office) => ({
                id: office?.officeId ?? office?.id,
                name: office?.officeName ?? office?.name,
              }),
            ),
            accountOwnerUserId: selectedOwnerId,
            t,
          });

          if (validation.action === "block") {
            toast.error(validation.message);
            return { pendingOfficeModal: false };
          }

          if (validation.action === "showOfficeModal") {
            // Authoritative office list for the target staff. Listing `officeNames`
            // can be stale/duplicated; only prompt when there is real ambiguity.
            let targetOffices = [];
            try {
              if (selectedOwnerId && targetUserId) {
                targetOffices = await getOfficesByOwnerAndUser(
                  selectedOwnerId,
                  targetUserId,
                );
              }
            } catch (error) {
              console.warn("Error resolving offices for drag-drop:", error);
            }

            if (targetOffices?.length === 1 && targetOffices[0]?.id != null) {
              const singleOfficeId = normalizeSchedulerOfficeId(
                targetOffices[0].id,
              );
              dropContextWithSource.isUnassignedSource =
                validation.isUnassignedSource;
              dropContextWithSource.targetOfficeId = singleOfficeId;
              if (validation.isShift ?? eventData?.isShift) {
                dropContextWithSource.shiftSourceOfficeId = singleOfficeId;
              } else {
                const { officeId: eventOfficeId } = resolveEventOrShiftOffice({
                  eventData,
                  sourceContext: draggedEvent?.sourceContext || {},
                  dropContext: dropContextWithSource,
                  ownerOfficeList: (dataAccessValues?.officeList || []).map(
                    (office) => ({
                      id: office?.officeId ?? office?.id,
                      name: office?.officeName ?? office?.name,
                    }),
                  ),
                });
                dropContextWithSource.makeEnterprise = Boolean(
                  eventOfficeId && eventOfficeId !== singleOfficeId,
                );
              }
            } else {
              setPendingOfficeDrop({
                eventItem,
                dropContext: {
                  ...dropContextWithSource,
                  isUnassignedSource: validation.isUnassignedSource,
                },
                isShift: validation.isShift ?? eventData?.isShift,
              });
              setIsOfficeSelectModalOpen(true);
              return { pendingOfficeModal: true };
            }
          } else {
            dropContextWithSource.isUnassignedSource =
              validation.isUnassignedSource;
            dropContextWithSource.targetOfficeId =
              validation.targetOfficeId ?? dropContextWithSource.targetOfficeId;
            dropContextWithSource.shiftSourceOfficeId =
              validation.shiftSourceOfficeId;
            dropContextWithSource.makeEnterprise = validation.makeEnterprise;
          }
        }

        const newDateTime = buildDateTimeForDrop(
          eventData,
          dropContextWithSource.targetDate,
        );
        const isUnassignedEvent =
          Boolean(dropContextWithSource.isUnassignedSource) ||
          isUnassignedSchedulerEvent(eventData);
        const isMovingToUnassigned = Boolean(
          dropContextWithSource.isMovingToUnassigned,
        );
        const isAssigningUnassignedToStaff = Boolean(
          dropContextWithSource.isUnassignedSource && targetUserId,
        );
        const hasStaffChange = Boolean(
          isMovingToUnassigned ||
          isAssigningUnassignedToStaff ||
          (sourceUserId &&
            targetUserId &&
            String(sourceUserId) !== String(targetUserId)),
        );

        if (hasStaffChange && !isAssigningUnassignedToStaff) {
          const activeEmployees = (eventData.eventEmployees || []).filter(
            (employee) => !employee?.isDeletedForThisSchedulerEvent,
          );
          const targetAlreadyAssigned = activeEmployees.some(
            (employee) =>
              String(employee.userId ?? employee.user?.id) ===
              String(targetUserId),
          );
          if (targetAlreadyAssigned) {
            showEventAlreadyExistsForUserError(eventData.isShift);
            return { pendingOfficeModal: false };
          }
        }

        const dateChangedResult = matchedBothDatesValues({
          eventDetail: eventData,
          repeatedEndDate: eventData.repeatedEndDate
            ? moment(eventData.repeatedEndDate).toDate()
            : moment().add(3, "month").toDate(),
          requestedDate: originalRequestedDate,
          eventDate: newDateTime.newDate,
        });
        const repeatedOptionChanged = matchedBothPatternValues({
          repeatedType: eventData.repeatedType || 1,
          repeatedTypeFrequency: eventData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: eventData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedSlotDate:
            eventData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||
            [],
          selectedWeek: eventData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedMonths:
            eventData.customRepeatPattern?.monthsOfYear?.map((m) => m?.month) ||
            [],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: eventData,
        });

        const hasDateChange = dateChangedResult.startDateChanged;
        const hasChanges = hasDateChange || hasStaffChange;

        const neverCheck =
          eventData.repeatedType ===
          addEditEventsConst.repeatedOptionsValues.never;
        const isNotDrafted = !eventData.isDraft;
        if (!neverCheck && !editType && hasChanges && isNotDrafted) {
          setPendingDragUpdate({
            eventData,
            dropContext: dropContextWithSource,
            anyChangedForDate: repeatedOptionChanged,
            originalRequestedDate,
          });
          setEditModalConfirmation(true);
          return;
        }

        await performEventUpdate(
          eventData,
          newDateTime,
          dropContextWithSource,
          editType || editTypesVariables.allEvent,
          originalRequestedDate,
        );

        if (
          dropContextWithSource.isUnassignedSource ||
          dropContextWithSource.isMovingToUnassigned ||
          isUnassignedEvent
        ) {
          refetchOfficeAgenda();
        }

        return { pendingOfficeModal: false };
      } catch (error) {
        toast.error(error.message || t("scheduler.updateFailed"));
        throw error;
      }
    },
    [
      t,
      buildDateTimeForDrop,
      performEventUpdate,
      showEventAlreadyExistsForUserError,
      draggedEvent,
      eventsWorkspaceMode,
      selectedOwnerId,
      dataAccessValues,
      refetchOfficeAgenda,
    ],
  );

  const handleOfficeModalConfirm = useCallback(
    async (selectedOffice) => {
      setIsOfficeSelectModalOpen(false);
      const pending = pendingOfficeDrop;
      if (!pending?.eventItem) {
        setPendingOfficeDrop(null);
        setIsDragging(false);
        setDraggedEvent(null);
        return;
      }

      setIsDragDropLoading(true);
      try {
        const originalRequestedDate = draggedEventDateRef.current
          ? draggedEventDateRef.current
          : moment(
              pending.eventItem.requestedDate || pending.eventItem.startTime,
            ).format("YYYY-MM-DD");
        const eventDetails = await getEventListDetails(
          pending.eventItem.id,
          originalRequestedDate,
        );
        const eventData = eventDetails?.data;
        const sourceUserId = pending.dropContext?.sourceUserId;
        const isUnassignedSource = Boolean(
          pending.dropContext?.isUnassignedSource,
        );
        const { officeId, makeEnterprise } = resolveEventAssignmentOffice({
          eventData,
          sourceUserId: isUnassignedSource ? null : sourceUserId,
          targetUserOffices: [selectedOffice],
          explicitTargetOfficeId: selectedOffice.id,
        });
        const resolvedOfficeId = officeId ?? selectedOffice.id;

        await updateEventAfterDrag(
          pending.eventItem,
          {
            ...pending.dropContext,
            targetOfficeId: resolvedOfficeId,
            // Shift office must follow the selected office on cross-office reassignment.
            shiftSourceOfficeId: pending.isShift
              ? resolvedOfficeId
              : pending.dropContext?.shiftSourceOfficeId,
            makeEnterprise: pending.isShift ? undefined : makeEnterprise,
            isUnassignedSource,
          },
          null,
          { skipValidation: true },
        );
      } finally {
        setIsDragDropLoading(false);
        setIsDragging(false);
        setDraggedEvent(null);
        setPendingOfficeDrop(null);
      }
    },
    [pendingOfficeDrop, updateEventAfterDrag],
  );

  const handleOfficeModalClose = useCallback(() => {
    setIsOfficeSelectModalOpen(false);
    setPendingOfficeDrop(null);
    setIsDragging(false);
    setDraggedEvent(null);
  }, []);

  const handleDragStart = useCallback(
    (e, eventItem, sourceContext) => {
      if (!canDragEvent(eventItem) || bulkSelectMode) {
        e.preventDefault();
        return;
      }
      draggedEventDateRef.current = moment(sourceContext?.requestedDate).format(
        "YYYY-MM-DD",
      );
      setDragPreviewCell(null);
      setDraggedEvent({
        eventItem,
        sourceContext,
      });
      setIsDragging(true);
      const rect = e.currentTarget.getBoundingClientRect();
      const dragImage = e.currentTarget.cloneNode(true);
      dragImage.style.opacity = "0";
      dragImage.style.position = "absolute";
      dragImage.style.top = "-1000px";
      document.body.appendChild(dragImage);
      e.dataTransfer.setDragImage(
        dragImage,
        e.clientX - rect.left,
        e.clientY - rect.top,
      );
      setTimeout(() => document.body.removeChild(dragImage), 0);
    },
    [canDragEvent, bulkSelectMode],
  );

  const handleCellDragOver = useCallback(
    (e, dropContext) => {
      if (!draggedEvent) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = "move";
      const isSameCell =
        !draggedEvent.sourceContext?.isUnassigned &&
        moment(draggedEvent.sourceContext?.requestedDate).format(
          "YYYY-MM-DD",
        ) === moment(dropContext?.requestedDate).format("YYYY-MM-DD") &&
        String(draggedEvent.sourceContext?.userId ?? "") ===
          String(dropContext?.userId ?? "");
      if (isSameCell) {
        setDragPreviewCell(null);
        return;
      }
      setDragPreviewCell({
        userId: dropContext.userId,
        requestedDate: moment(dropContext.requestedDate).format("YYYY-MM-DD"),
      });
    },
    [draggedEvent],
  );

  const resolveStaffListingUser = useCallback(
    (userId, fallbackUser) => {
      if (
        Array.isArray(fallbackUser?.officeNames) ||
        typeof fallbackUser?.officeNames === "string"
      ) {
        return fallbackUser;
      }

      for (const day of agendaFilter || []) {
        const row = (day?.officeSchedulerList || []).find(
          (entry) => String(entry?.user?.id) === String(userId),
        );
        if (row?.user) return row.user;
      }

      return fallbackUser;
    },
    [agendaFilter],
  );

  const handleCellDrop = useCallback(
    async (e, dropContext) => {
      e.preventDefault();
      setDragPreviewCell(null);
      if (!draggedEvent?.eventItem) {
        setIsDragging(false);
        setDraggedEvent(null);
        return;
      }
      const source = draggedEvent.sourceContext || {};
      const isSameCell =
        !source.isUnassigned &&
        moment(source.requestedDate).format("YYYY-MM-DD") ===
          moment(dropContext?.requestedDate).format("YYYY-MM-DD") &&
        String(source.userId ?? "") === String(dropContext?.userId ?? "");
      if (isSameCell) {
        setIsDragging(false);
        setDraggedEvent(null);
        return;
      }
      const context = {
        targetDate: dropContext.requestedDate,
        targetUserId: dropContext.userId,
        targetOfficeId: draggedEvent?.eventItem?.isShift
          ? null
          : (dropContext.officeId ?? draggedEvent?.eventItem?.officeId ?? null),
        targetUser: resolveStaffListingUser(
          dropContext.userId,
          dropContext.user,
        ),
        sourceUserId: source.userId,
        sourceOfficeId:
          source.officeId ??
          draggedEvent?.eventItem?.officeId ??
          draggedEvent?.eventItem?.office?.id ??
          draggedEvent?.eventItem?.office?.officeId,
        sourceOfficeName:
          source.officeName ??
          draggedEvent?.eventItem?.officeName ??
          draggedEvent?.eventItem?.eventEmployeeOfficeName ??
          draggedEvent?.eventItem?.officeNameList ??
          draggedEvent?.eventItem?.office?.name ??
          draggedEvent?.eventItem?.office?.officeName,
        isUnassignedSource: Boolean(source.isUnassigned),
        isShift: Boolean(source.isShift ?? draggedEvent?.eventItem?.isShift),
      };

      if (eventsWorkspaceMode) {
        const ownerOfficeList = (dataAccessValues?.officeList || []).map(
          (office) => ({
            id: office?.officeId ?? office?.id,
            name: office?.officeName ?? office?.name,
          }),
        );
        const listingShiftValidation = validateShiftListingStaffDrop({
          isShift: context.isShift,
          shiftOfficeName: context.sourceOfficeName,
          sourceUserId: context.sourceUserId,
          targetUserId: context.targetUserId,
          targetUser: context.targetUser,
          isUnassignedSource: context.isUnassignedSource,
          ownerOfficeList,
          accountOwnerUserId: selectedOwnerId,
          eventData: draggedEvent?.eventItem,
          t,
        });

        if (listingShiftValidation?.action === "block") {
          toast.error(listingShiftValidation.message);
          setIsDragging(false);
          setDraggedEvent(null);
          return;
        }
      }
      setIsDragDropLoading(true);
      let pendingOfficeModal = false;
      try {
        const result = await updateEventAfterDrag(
          draggedEvent.eventItem,
          context,
        );
        pendingOfficeModal = Boolean(result?.pendingOfficeModal);
      } finally {
        setIsDragDropLoading(false);
        if (!pendingOfficeModal) {
          setIsDragging(false);
          setDraggedEvent(null);
        }
      }
    },
    [
      draggedEvent,
      updateEventAfterDrag,
      eventsWorkspaceMode,
      dataAccessValues,
      selectedOwnerId,
      t,
      resolveStaffListingUser,
    ],
  );

  const handleDragEnd = useCallback(() => {
    if (!isDragDropLoading && !isOfficeSelectModalOpen) {
      setIsDragging(false);
      setDraggedEvent(null);
      setDragPreviewCell(null);
    }
  }, [isDragDropLoading, isOfficeSelectModalOpen]);

  const handleUnassignedCellDragOver = useCallback(
    (e, day) => {
      if (!draggedEvent) return;
      if (
        !canDropEventToUnassignedSection(
          draggedEvent.eventItem,
          draggedEvent.sourceContext,
        )
      ) {
        return;
      }
      e.preventDefault();
      e.dataTransfer.dropEffect = "move";
      const targetDate = day?.dateStr || moment(day?.date).format("YYYY-MM-DD");
      const sourceDate = serializeSchedulerHistoryDate(
        draggedEvent.sourceContext?.requestedDate,
      );
      const isFromUnassigned = Boolean(
        draggedEvent.sourceContext?.isUnassigned,
      );
      if (isFromUnassigned && sourceDate === targetDate) {
        setDragPreviewCell(null);
        return;
      }
      setDragPreviewCell({
        userId: null,
        requestedDate: targetDate,
        isUnassignedRow: true,
      });
    },
    [draggedEvent],
  );

  const handleUnassignedCellDrop = useCallback(
    async (e, day) => {
      e.preventDefault();
      setDragPreviewCell(null);
      if (!draggedEvent?.eventItem) {
        setIsDragging(false);
        setDraggedEvent(null);
        return;
      }

      const source = draggedEvent.sourceContext || {};
      const isFromUnassigned = Boolean(source.isUnassigned);

      if (!canDropEventToUnassignedSection(draggedEvent.eventItem, source)) {
        setIsDragging(false);
        setDraggedEvent(null);
        return;
      }

      const targetDate = day?.dateStr || moment(day?.date).format("YYYY-MM-DD");
      const sourceDate = serializeSchedulerHistoryDate(source.requestedDate);

      if (isFromUnassigned && sourceDate === targetDate) {
        setIsDragging(false);
        setDraggedEvent(null);
        return;
      }

      setIsDragDropLoading(true);
      try {
        await updateEventAfterDrag(draggedEvent.eventItem, {
          targetDate,
          targetUserId: null,
          sourceUserId: isFromUnassigned ? null : (source.userId ?? null),
          sourceOfficeId: source.officeId ?? draggedEvent.eventItem?.officeId,
          sourceOfficeName:
            source.officeName ?? draggedEvent.eventItem?.officeName,
          isUnassignedSource: isFromUnassigned,
          isMovingToUnassigned: !isFromUnassigned,
          isShift: Boolean(source.isShift ?? draggedEvent.eventItem?.isShift),
        });
        refetchOfficeAgenda();
      } finally {
        setIsDragDropLoading(false);
        setIsDragging(false);
        setDraggedEvent(null);
      }
    },
    [draggedEvent, updateEventAfterDrag, refetchOfficeAgenda],
  );
  const getAppointmentsView = (
    item,
    index,
    searchKey,
    requestedDate,
    staffName,
    hideOrShow,
  ) => {
    const thisHoverKey = `${searchKey}_${index}`;
    const data = getUsefulInfo(item);
    return (
      <div
        key={index}
        className={
          styles["scheduler-event-box"] + " " + styles["light-purple-bg"]
        }
        style={hideOrShow ?? {}}
        onClick={() => setHoverKey(thisHoverKey)}
      >
        {(displaySettingNotApplied || viewSettingFilter.includes("tag")) && (
          <div className={styles["event-tag"] + " " + styles["dark-grey-bg"]}>
            {t("scheduler.agenda.appointmentTag")}
          </div>
        )}
        {(displaySettingNotApplied ||
          viewSettingFilter.includes("timeString")) &&
          data?.timeString && (
            <div className={styles["event-date"]}>
              {data.timeString}({data?.timezoneCode})
            </div>
          )}
        {canShowOfficeName &&
          (displaySettingNotApplied ||
            viewSettingFilter.includes("officeName")) && (
            <div className={styles["event-office"]}>{data.officeName}</div>
          )}
        {displaySettingNotApplied && data.location && (
          <div className={styles["event-office"]}>
            <img
              src={require("assets/images/pin_drop_black.svg").default}
              alt="caret"
            />
            <span className="ml-1 break_all ">{data.location}</span>
          </div>
        )}
        {(displaySettingNotApplied || viewSettingFilter.includes("title")) && (
          <div className={styles["event-type"]}>
            {t("scheduler.agenda.appointmentTitle")}
          </div>
        )}
        {thisHoverKey === hoverKey &&
          getPopupView(
            item,
            "light-purple-bg",
            "dark-grey-bg",
            requestedDate,
            staffName,
          )}
      </div>
    );
  };

  const getSchedulerEventsView = (
    item,
    index,
    searchKey,
    requestedDate,
    staffName,
    hideOrShow,
    sourceContext = {},
    isDragPreview = false,
  ) => {
    const thisHoverKey = `${searchKey}_${index}`;
    const data = getUsefulInfo(item);
    const createdByOthers = item?.isShift && profile?.id !== item?.createdById;
    const isMeasurementCard =
      hideOrShow?.visibility === "hidden" || hideOrShow?.position === "fixed";
    const canShowEventMenu =
      !isDragPreview &&
      !isMeasurementCard &&
      canShowEventCardMenu(item, profile, {
        isOwner,
        canEditAndViewOthersData,
      });
    const selectionUserId = sourceContext?.isUnassigned
      ? null
      : (sourceContext?.userId ?? item.userId ?? null);
    const isUnassignedSelection = Boolean(sourceContext?.isUnassigned);
    const selectionKey = getEventShiftSelectionKey(
      item.id,
      requestedDate,
      selectionUserId,
    );
    const eventMenuKey = [
      item.id,
      eventsWorkspaceMode ? item.userId : null,
      moment(requestedDate).format("YYYY-MM-DD"),
      index,
      isMeasurementCard ? "probe" : "card",
    ]
      .filter((part) => part !== null && part !== undefined)
      .join("_");
    const isEventSelected = isEventShiftSelected(
      selectedEventKeys,
      item.id,
      requestedDate,
      selectionUserId,
    );
    const canDrag = !isDragPreview && canDragEvent(item) && !bulkSelectMode;
    const draggedSourceDate = draggedEvent?.sourceContext?.requestedDate
      ? moment(draggedEvent.sourceContext.requestedDate).format("YYYY-MM-DD")
      : "";
    const currentDateKey = requestedDate
      ? moment(requestedDate).format("YYYY-MM-DD")
      : "";
    const isSameDragSource = sourceContext?.isUnassigned
      ? Boolean(draggedEvent?.sourceContext?.isUnassigned)
      : String(
          draggedEvent?.sourceContext?.userId ??
            draggedEvent?.eventItem?.userId ??
            "",
        ) === String(sourceContext?.userId ?? item?.userId ?? "");
    const isDragged =
      !isDragPreview &&
      isDragging &&
      draggedEvent?.eventItem?.id === item.id &&
      draggedSourceDate === currentDateKey &&
      isSameDragSource;

    return (
      <div
        key={index}
        className={
          styles["scheduler-event-box"] +
          " " +
          (eventsWorkspaceMode ? "" : styles[data.backgroudColorClass]) +
          (eventsWorkspaceMode && bulkSelectMode && !isDragPreview
            ? " " + styles["bulk-select-event-box"]
            : "")
        }
        style={{
          ...(hideOrShow ?? {}),
          ...(isDragPreview
            ? {
                position: "relative",
                width: "100%",
                marginBottom: 0,
                opacity: 0.7,
                cursor: "grab",
                backgroundColor: item?.isDraft ? "#FEF3D7" : "#C8E36433",
              }
            : {}),
          ...(eventsWorkspaceMode && item?.isDraft && !isDragPreview
            ? { backgroundColor: "#FEF3D7" }
            : {}),
          ...(isDragged ? { opacity: 0 } : {}),
          cursor: isDragPreview ? "grab" : canDrag ? "grab" : "pointer",
        }}
        draggable={canDrag}
        onDragStart={
          canDrag ? (e) => handleDragStart(e, item, sourceContext) : undefined
        }
        onDragEnd={canDrag ? handleDragEnd : undefined}
        onClick={() => {
          if (isDragPreview || isDragging) return;
          if (eventsWorkspaceMode && bulkSelectMode) {
            onEventSelectionToggle?.(selectionKey, {
              id: item.id,
              date: moment(requestedDate).format("YYYY-MM-DD"),
              isDraft: item.isDraft,
              isShift: Boolean(item.isShift),
              publishAsEvent: item.publishAsEvent,
              userId: selectionUserId,
              isUnassigned: isUnassignedSelection,
            });
            return;
          }
          if (
            data.createdByMe ||
            (createdByOthers && canEditAndViewOthersData(item?.officeId))
          ) {
            goToDetails(
              data.id,
              constants.agendaType.EVENT,
              true,
              requestedDate,
            );
          } else {
            setHoverKey(thisHoverKey);
          }
        }}
      >
        {eventsWorkspaceMode && bulkSelectMode && !isDragPreview && (
          <div
            className={`ch-checkbox ${styles["bulk-select-checkbox"]}`}
            onClick={(e) => e.stopPropagation()}
          >
            <label>
              <input
                type="checkbox"
                checked={isEventSelected}
                onChange={() =>
                  onEventSelectionToggle?.(selectionKey, {
                    id: item.id,
                    date: moment(requestedDate).format("YYYY-MM-DD"),
                    isDraft: item.isDraft,
                    isShift: Boolean(item.isShift),
                    publishAsEvent: item.publishAsEvent,
                    userId: selectionUserId,
                    isUnassigned: isUnassignedSelection,
                  })
                }
              />
              <span />
            </label>
          </div>
        )}
        {(displaySettingNotApplied ||
          viewSettingFilter.includes("tag") ||
          (eventsWorkspaceMode && canShowEventMenu)) && (
          <div className="d-flex justify-content-between align-items-start gap-2">
            {(displaySettingNotApplied ||
              viewSettingFilter.includes("tag")) && (
              <div className="d-flex gap-1 flex-wrap">
                {eventsWorkspaceMode && item?.isDraft && (
                  <div
                    className={
                      styles["event-tag"] + " " + styles["draft-warning-bg"]
                    }
                  >
                    {t("scheduler.isDraft")}
                  </div>
                )}
                <div
                  className={
                    styles["event-tag"] + " " + styles["theme-green-bg"]
                  }
                >
                  {createdByOthers
                    ? t("scheduler.agenda.shiftByOthers")
                    : item?.isShift
                      ? t("scheduler.agenda.shiftTag")
                      : t("scheduler.agenda.eventTag")}
                </div>
              </div>
            )}
            {eventsWorkspaceMode && canShowEventMenu && (
              <Dropdown
                isOpen={openEventMenuKey === eventMenuKey}
                toggle={createEventMenuToggleHandler(eventMenuKey)}
                onClick={(e) => e.stopPropagation()}
                className={`interactive-dropdown ms-auto flex-shrink-0 ${styles["interactive-drp-dwn-space"]} `}
              >
                <DropdownToggle
                  tag="div"
                  className="cursor-pointer d-flex align-items-center"
                  style={{ lineHeight: 0 }}
                >
                  <ThreeDots size={14} color="#6B7280" />
                </DropdownToggle>
                <DropdownMenu
                  end
                  container="body"
                  className={styles["office-dropdown-menu"]}
                >
                  <DropdownItem
                    className={styles["office-dropdown-item"]}
                    onClick={(e) => {
                      e.stopPropagation();
                      openQuickEdit(
                        {
                          ...item,
                          userId: item?.userId ?? sourceContext?.userId,
                          officeId:
                            item?.officeId ??
                            sourceContext?.officeId ??
                            item?.office?.id ??
                            item?.office?.officeId,
                          officeName:
                            item?.officeName ??
                            sourceContext?.officeName ??
                            item?.eventEmployeeOfficeName ??
                            item?.officeNameList ??
                            item?.office?.name ??
                            item?.office?.officeName,
                        },
                        {
                          search: effectiveOwnerIdString
                            ? `?${effectiveOwnerIdString}`
                            : "",
                        },
                      );
                    }}
                  >
                    {t("scheduler.quickEdit")}
                  </DropdownItem>
                  <DropdownItem
                    className={styles["office-dropdown-item"]}
                    onClick={(e) => {
                      e.stopPropagation();
                      onDuplicateEvent(item, requestedDate, 1);
                    }}
                  >
                    {t("scheduler.duplicateEvent", {
                      eventOrShiftOrLeave: item?.isShift
                        ? t("accountOwner.shiftTab")
                        : t("accountOwner.eventTab"),
                    })}
                  </DropdownItem>
                  <DropdownItem
                    className={styles["office-dropdown-item"]}
                    toggle={false}
                    onClick={handleMultipleDuplicatesClick(
                      eventMenuKey,
                      item,
                      requestedDate,
                    )}
                  >
                    {t("scheduler.multipleDuplicates")}
                  </DropdownItem>
                  <DropdownItem
                    className={styles["office-dropdown-item"]}
                    onClick={(e) => {
                      e.stopPropagation();
                      openAssignUsersModal(item, requestedDate);
                    }}
                  >
                    {t("scheduler.assignStaff")}
                  </DropdownItem>
                  {/* <DropdownItem
                    className={styles["office-dropdown-item"]}
                    onClick={(e) => {
                      e.stopPropagation();
                      toast(
                        t("scheduler.actionComingSoon", {
                          action: t("scheduler.unassignUsers"),
                        }),
                      );
                    }}
                  >
                    {t("scheduler.unassignUsers")}
                  </DropdownItem> */}
                  <DropdownItem
                    className={styles["office-dropdown-item"]}
                    onClick={(e) => {
                      e.stopPropagation();
                      const isUnassignedCard =
                        isUnassignedSelection ||
                        isUnassignedSchedulerEvent(item);
                      handleCardDeleteClick(
                        item,
                        moment(requestedDate).format("YYYY-MM-DD"),
                        {
                          selectedUserIdsFromStaffView:
                            !isUnassignedCard && item?.userId
                              ? [item.userId]
                              : [],
                          lockSelectedUsers:
                            !isUnassignedCard && Boolean(item?.userId),
                        },
                        {
                          search: effectiveOwnerIdString
                            ? `?${effectiveOwnerIdString}`
                            : "",
                        },
                      );
                    }}
                  >
                    <span style={{ color: "#EE4F4F" }}>
                      {t("scheduler.deleteEvent", {
                        eventOrShift: item?.isShift
                          ? t("accountOwner.shiftTab")
                          : t("accountOwner.eventTab"),
                      })}
                    </span>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            )}
          </div>
        )}
        {(displaySettingNotApplied ||
          viewSettingFilter.includes("timeString")) &&
          data?.timeString && (
            <div className={styles["event-date"]}>
              {data.timeString}({data?.timezoneCode})
            </div>
          )}
        {canShowOfficeName &&
          (displaySettingNotApplied ||
            viewSettingFilter.includes("officeName")) && (
            <div className={styles["event-office"]}>{data.officeName}</div>
          )}
        {displaySettingNotApplied && data.location && (
          <div className={styles["event-office"]}>
            <img
              src={require("assets/images/pin_drop_black.svg").default}
              alt="caret"
            />
            <span className="ml-1 break_all ">{data.location}</span>
          </div>
        )}
        {(displaySettingNotApplied || viewSettingFilter.includes("title")) &&
          (item?.isShift ? (
            viewSettingFilter.includes("title") && (
              <div className={styles["event-type"]}>
                {data.title?.trim()
                  ? data.title
                  : t("scheduler.agenda.shiftTag")}
              </div>
            )
          ) : (
            <div className={styles["event-type"]}> {data.title} </div>
          ))}
        {thisHoverKey === hoverKey &&
          getPopupView(
            item,
            data.backgroudColorClass,
            "theme-green-bg",
            requestedDate,
            staffName,
          )}
      </div>
    );
  };
  const getSchedulerBusySlotsView = (
    item,
    index,
    isSchedulerBusySlot,
    searchKey,
    requestedDate,
    staffName,
    hideOrShow,
  ) => {
    const thisHoverKey = `${searchKey}_${index}`;
    const data = getUsefulInfo(item);
    let officeName = data?.officeName?.split(",")?.map((item) => {
      return {
        name: item,
        id: item,
      };
    });
    return (
      <div
        key={index}
        className={
          styles["scheduler-event-box"] +
          " " +
          styles["light-orange-bg"] +
          " cursor-pointer "
        }
        style={hideOrShow ?? {}}
        onClick={() => {
          if (data.createdByMe) {
            goToDetails(
              data.id,
              constants.agendaType.BUSY_SLOT,
              data.createdByMe,
              requestedDate,
            );
          } else {
            setHoverKey(thisHoverKey);
            setHoverBusySlotKey("");
          }
        }}
      >
        {(displaySettingNotApplied || viewSettingFilter.includes("tag")) && (
          <div className={styles["event-tag"] + " " + styles["dark-orange-bg"]}>
            {t("scheduler.agenda.busyTag")}
          </div>
        )}
        {(displaySettingNotApplied ||
          viewSettingFilter.includes("timeString")) &&
          data?.timeString && (
            <div className={styles["event-date"]}>{data.timeString}</div>
          )}
        {(displaySettingNotApplied ||
          viewSettingFilter.includes("officeName")) && (
          <div className={styles["event-office"]}>
            <MoreTagsFunction
              parentClass="text-break text-wrap"
              value={officeName || []}
              lastIndex={2}
              clickHandler={(e) =>
                handlePopupToggle1(e, setNonInvitePopup, thisHoverKey)
              }
              mapFn={(member) => `${member?.name}`}
            />
          </div>
        )}
        {displaySettingNotApplied && data.location && (
          <div className={styles["event-office"]}>
            <img
              src={require("assets/images/pin_drop_black.svg").default}
              alt="caret"
            />
            <span className="ml-1 break_all ">{data.location}</span>
          </div>
        )}
        {(displaySettingNotApplied || viewSettingFilter.includes("title")) && (
          <div className={styles["event-type"]}> {data.title} </div>
        )}
        {thisHoverKey === hoverKey &&
          getPopupView(
            item,
            "light-orange-bg",
            "dark-orange-bg",
            requestedDate,
            staffName,
          )}

        {thisHoverKey === hoverBusySlotKey && nonInvitePopup && (
          <InviteesPopup
            position={invitePopupPosition}
            handleInvitePopupToggle={(e) =>
              handlePopupToggle1(e, setNonInvitePopup)
            }
            list={officeName}
            showRoleAndOffice={false}
            isForEvent={true}
            isfromBusySlot={true}
            onlyOfffice
          />
        )}
      </div>
    );
  };
  const getLeavesView = (
    item,
    index,
    searchKey,
    requestedDate,
    staffName,
    hideOrShow,
  ) => {
    const thisHoverKey = `${searchKey}_${index}`;
    const data = getUsefulInfo(item);

    const { Highlighter, main, text } = leaveClasses(item?.statusId);
    return (
      <div
        key={index}
        className={styles["scheduler-event-box"] + " " + styles[main]}
        onClick={() => setHoverKey(thisHoverKey)}
        style={hideOrShow ?? {}}
      >
        <div className={styles["event-tag"] + " " + styles[Highlighter]}>
          {t(text)}
        </div>

        {canShowOfficeName &&
          (displaySettingNotApplied ||
            viewSettingFilter.includes("officeName")) && (
            <div className={styles["event-office"]}>{data.officeName}</div>
          )}
        {displaySettingNotApplied && data.location && (
          <div className={styles["event-office"]}>
            <img
              src={require("assets/images/pin_drop_black.svg").default}
              alt="caret"
            />
            <span className="ml-1 break_all ">{data.location}</span>
          </div>
        )}
        {(displaySettingNotApplied || viewSettingFilter.includes("title")) &&
          !!data?.title && (
            <div className={styles["event-type"]}>{data.title}</div>
          )}
        {thisHoverKey === hoverKey &&
          getPopupView(item, main, Highlighter, requestedDate, staffName)}
      </div>
    );
  };
  const getVisibleDayItems = (dayItem, staffUser) => {
    const {
      appointments,
      leaves,
      schedulerBusySlots,
      schedulerEvents,
      appointmentSlots,
    } = dayItem || {};

    const allItems = eventsWorkspaceMode
      ? filterEventWorkspaceSchedulerEvents(schedulerEvents)
      : addAllItemsTypes({
          schedulerEvents,
          appointments,
          schedulerBusySlots,
          appointmentSlots,
          leaves,
        });

    if (eventsWorkspaceMode) {
      return filterEventsWorkspaceBySearch(allItems, searchValue);
    }
    return filterEventsBySearch(allItems, staffUser, searchValue);
  };

  const shouldShowUserSeeMore = (dayData, staffUser) => {
    if (!Array.isArray(dayData) || dayData.length === 0) return false;

    const visibleItemsByDay = dayData.map((dayItem) =>
      getVisibleDayItems(dayItem, staffUser),
    );
    const totalVisibleItems = visibleItemsByDay.reduce(
      (total, items) => total + items.length,
      0,
    );

    if (totalVisibleItems === 0) return false;

    return visibleItemsByDay.some((items) => items.length > 2);
  };
  const toggleSeeMoreForUser = (userId) => {
    if (seeMoreUsers.includes(userId)) {
      setSeeMoreUsers((state) => state.filter((id) => id !== userId));
    } else {
      setSeeMoreUsers((state) => [...state, userId]);
    }
    setSeeMoreOnCalender("");
  };
  const toggleSeeMoreOnCalender = (searchKey) => {
    if (seeMoreOnCalender === searchKey) {
      setSeeMoreOnCalender("");
    } else {
      setSeeMoreOnCalender(searchKey);
    }
  };

  const handleDateClick = (clickedDate) => {
    if (isSchedulingAssistant) {
      setHoverKey("");
      setHoverBusySlotKey("");
      setSeeMoreOnCalender("");
    }

    if (onDateChange) {
      onDateChange(clickedDate);
    }
  };

  let userData = [];
  let tableJsx = null;
  let holidayRowJsx = null;

  let filteredAgendaFilter = agendaFilter;
  if (isEnterpriseFilterActive) {
    filteredAgendaFilter = (agendaFilter || []).map((date) => {
      const filteredOfficeSchedulerList = (date.officeSchedulerList || []).map(
        (item) => ({
          ...item,
          appointments: (item.appointments || []).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          leaves: (item.leaves || []).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          schedulerBusySlots: (item.schedulerBusySlots || []).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          schedulerEvents: (item.schedulerEvents || []).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          appointmentSlots: (item.appointmentSlots || []).filter(
            (e) => e && e?.isEnterprise === true,
          ),
        }),
      );
      return {
        ...date,
        officeSchedulerList: filteredOfficeSchedulerList,
      };
    });
  }
  const dontRun = cellRef.current.length && !isFromDashBoard;
  useEffect(() => {
    setTimeout(() => {
      if (dontRun && viewSettingFilter?.length) {
        // reset
        cellRef.current.forEach(({ child }) => {
          Object.values(child).forEach((allValues) => {
            if (allValues.cell && allValues.seeMore) {
              allValues.maxVisibleEvents = 2;
            }
          });
        });
        setSeeMoreMax({});
      }
    }, 400);
  }, [viewSettingFilter]);
  useEffect(() => {
    setTimeout(() => {
      if (dontRun) {
        cellRef.current.forEach(({ child }) => {
          Object.values(child).forEach((cell) => {
            const allValues = cell;
            if (
              allValues.cell &&
              allValues.seeMore &&
              viewSettingFilter.length
            ) {
              const cellElement = cell.cell.children.length;
              calculateMaxVisibleElements({
                cell,
                viewSettingFilter,
                resetDateBox: 0,
                checkForContinue({ firstOrLast }) {
                  return cellElement - 2 <= firstOrLast;
                },
                lastEventIndex: cellElement - 2,
                moreBoxIndex: cellElement - 1,
              });
            }
          });
        });
        setSeeMoreMax({});
      }
    }, 500);
  }, [agenda, viewSettingFilter]);

  useEffect(() => {
    if (
      !eventsWorkspaceMode ||
      !onVisibleDraftEventsUpdate ||
      !agendaFilter?.length
    ) {
      return;
    }
    let agendaData = agendaFilter;
    if (isEnterpriseFilterActive) {
      agendaData = (agendaFilter || []).map((date) => ({
        ...date,
        officeSchedulerList: (date.officeSchedulerList || []).map((item) => ({
          ...item,
          schedulerEvents: (item.schedulerEvents || []).filter(
            (e) => e?.isEnterprise === true,
          ),
        })),
      }));
    }
    const draftItems = [];
    agendaData.forEach((date) => {
      const dayDate = date?.requestedDate
        ? moment(date.requestedDate).format("YYYY-MM-DD")
        : date?.date
          ? moment(date.date).format("YYYY-MM-DD")
          : null;
      const { officeSchedulerList } = date;
      (officeSchedulerList || []).forEach((staffRow) => {
        const staffUserId =
          staffRow?.user?.id ?? staffRow?.userId ?? staffRow?.id ?? null;
        const filteredEvents = filterEventsWorkspaceBySearch(
          filterEventWorkspaceSchedulerEvents(staffRow?.schedulerEvents),
          searchValue,
        );
        filteredEvents.forEach((ev) => {
          if (!ev.isDraft || isUnassignedSchedulerEvent(ev)) return;
          draftItems.push({
            id: ev.id,
            isShift: Boolean(ev.isShift),
            userId: ev.userId ?? staffUserId,
            ...(dayDate ? { date: dayDate } : {}),
          });
        });
      });
    });
    onVisibleDraftEventsUpdate(draftItems);
  }, [
    agendaFilter,
    eventsWorkspaceMode,
    eventShiftFilter,
    appliedPublishedDraftFilter,
    isEnterpriseFilterActive,
    searchValue,
    onVisibleDraftEventsUpdate,
  ]);

  const firstDayOfficeSchedulerList =
    filteredAgendaFilter?.[0]?.officeSchedulerList;

  const unassignedStaffDaysData = useMemo(() => {
    if (!eventsWorkspaceMode || !isWeekly || !sortStaffBy) {
      return [];
    }

    return buildUnassignedEventsFromAssignerByEmployee(
      weeklyData?.data || [],
      weekData,
    ).map((day) => {
      const filteredEvents = filterEventWorkspaceSchedulerEvents(day.events);
      return {
        ...day,
        events: filterEventsWorkspaceBySearch(filteredEvents, searchValue),
      };
    });
  }, [
    eventsWorkspaceMode,
    isWeekly,
    sortStaffBy,
    weeklyData?.data,
    weekData,
    eventShiftFilter,
    appliedPublishedDraftFilter,
    isEnterpriseFilterActive,
    currentUserId,
    searchValue,
  ]);

  useEffect(() => {
    if (
      !eventsWorkspaceMode ||
      !onVisibleClearableItemsUpdate ||
      !agendaFilter?.length
    ) {
      return;
    }
    let agendaData = agendaFilter;
    if (isEnterpriseFilterActive) {
      agendaData = (agendaFilter || []).map((date) => ({
        ...date,
        officeSchedulerList: (date.officeSchedulerList || []).map((item) => ({
          ...item,
          schedulerEvents: (item.schedulerEvents || []).filter(
            (e) => e?.isEnterprise === true,
          ),
        })),
      }));
    }
    const clearableItems = [];
    agendaData.forEach((date) => {
      const { officeSchedulerList } = date;
      (officeSchedulerList || []).forEach((staffRow) => {
        const staffUserId =
          staffRow?.user?.id ?? staffRow?.userId ?? staffRow?.id ?? null;
        filterEventWorkspaceSchedulerEvents(staffRow?.schedulerEvents).forEach(
          (ev) => {
            if (ev?.id != null) {
              const userId = isUnassignedSchedulerEvent(ev)
                ? null
                : (ev.userId ?? staffUserId);
              clearableItems.push({
                id: ev.id,
                isShift: Boolean(ev.isShift),
                userId,
              });
            }
          },
        );
      });
    });
    unassignedStaffDaysData.forEach((day) => {
      (day.events || []).forEach((ev) => {
        if (ev?.id != null) {
          clearableItems.push({
            id: ev.id,
            isShift: Boolean(ev.isShift),
            userId: null,
          });
        }
      });
    });
    onVisibleClearableItemsUpdate(clearableItems);
  }, [
    agendaFilter,
    eventsWorkspaceMode,
    eventShiftFilter,
    appliedPublishedDraftFilter,
    isEnterpriseFilterActive,
    onVisibleClearableItemsUpdate,
    unassignedStaffDaysData,
  ]);

  useEffect(() => {
    if (
      !eventsWorkspaceMode ||
      !onSelectableEventsUpdate ||
      !agendaFilter?.length
    ) {
      return;
    }
    let agendaData = agendaFilter;
    if (isEnterpriseFilterActive) {
      agendaData = (agendaFilter || []).map((date) => ({
        ...date,
        officeSchedulerList: (date.officeSchedulerList || []).map((item) => ({
          ...item,
          schedulerEvents: (item.schedulerEvents || []).filter(
            (e) => e?.isEnterprise === true,
          ),
        })),
      }));
    }
    const eventsMap = {};
    agendaData.forEach((date) => {
      const { requestedDate, officeSchedulerList } = date;
      (officeSchedulerList || []).forEach((staffRow) => {
        const staffUserId =
          staffRow?.user?.id ?? staffRow?.userId ?? staffRow?.id ?? null;
        filterEventWorkspaceSchedulerEvents(staffRow?.schedulerEvents).forEach(
          (ev) => {
            const userId = isUnassignedSchedulerEvent(ev)
              ? null
              : (ev.userId ?? staffUserId);
            const key = getEventShiftSelectionKey(ev.id, requestedDate, userId);
            eventsMap[key] = {
              id: ev.id,
              date: moment(requestedDate).format("YYYY-MM-DD"),
              isDraft: ev.isDraft,
              isShift: Boolean(ev.isShift),
              publishAsEvent: ev.publishAsEvent,
              userId,
              isUnassigned: false,
            };
          },
        );
      });
    });

    // Include unassigned row cards so Select All checks/unchecks them too.
    unassignedStaffDaysData.forEach((day) => {
      const requestedDate = day.dateStr || day.date;
      (day.events || []).forEach((ev) => {
        const key = getEventShiftSelectionKey(ev.id, requestedDate, null);
        eventsMap[key] = {
          id: ev.id,
          date: moment(requestedDate).format("YYYY-MM-DD"),
          isDraft: ev.isDraft,
          isShift: Boolean(ev.isShift),
          publishAsEvent: ev.publishAsEvent,
          userId: null,
          isUnassigned: true,
        };
      });
    });

    onSelectableEventsUpdate(eventsMap);
  }, [
    agendaFilter,
    eventsWorkspaceMode,
    eventShiftFilter,
    appliedPublishedDraftFilter,
    isEnterpriseFilterActive,
    onSelectableEventsUpdate,
    unassignedStaffDaysData,
  ]);

  useEffect(() => {
    if (!eventsWorkspaceMode || !settotalEvents || !sortStaffBy) {
      return;
    }

    const visibleEvents = [];

    (filteredAgendaFilter || []).forEach((date) => {
      (date.officeSchedulerList || []).forEach((staffRow) => {
        const filtered = filterEventWorkspaceSchedulerEvents(
          staffRow?.schedulerEvents,
        );
        visibleEvents.push(
          ...filterEventsWorkspaceBySearch(filtered, searchValue),
        );
      });
    });

    unassignedStaffDaysData.forEach((day) => {
      visibleEvents.push(...(day.events || []));
    });

    settotalEvents(countSchedulerEventOccurrences(visibleEvents));
  }, [
    eventsWorkspaceMode,
    settotalEvents,
    sortStaffBy,
    filteredAgendaFilter,
    unassignedStaffDaysData,
    searchValue,
    eventShiftFilter,
    appliedPublishedDraftFilter,
    isEnterpriseFilterActive,
    currentUserId,
  ]);

  if (filteredAgendaFilter?.length && firstDayOfficeSchedulerList?.length) {
    userData = cloneDeep(firstDayOfficeSchedulerList).map((item) => ({
      user: item.user,
      data: [],
    }));

    filteredAgendaFilter?.forEach((date) => {
      const { requestedDate, officeSchedulerList, holidayList } = date;
      (officeSchedulerList || []).forEach((data, userIndex) => {
        const { user, ...rest } = data;
        userData[userIndex].data.push({ requestedDate, holidayList, ...rest });
      });
    });

    if (eventsWorkspaceMode && sortStaffBy) {
      const loggedInUserId = currentUserId ?? profile?.id;
      userData.sort((a, b) =>
        compareStaffByWeeklySortOption(a, b, sortStaffBy, loggedInUserId),
      );
    }

    tableJsx = userData.map((ud, ui) => {
      const { user, data } = ud;
      const {
        fullName,
        profilePic,
        id: userId,
        emailId,
        designationNames,
        officeNames,
        contactNumber,
      } = user || {};

      if (!cellRef.current[ui]) {
        cellRef.current[ui] = {
          child: {},
        };
      }
      const dontShowMore = !seeMoreUsers.includes(userId);

      return (
        <tr key={ui}>
          <th
            style={
              isFromDashBoard
                ? {
                    maxWidth: "150px",
                    minWidth: "150px",
                    borderLeft: "none",
                  }
                : {}
            }
          >
            <div className={styles["scheduler-client-box"]}>
              <div
                className={styles["client-img"]}
                onClick={() => isFromDashBoard && handlePopupToggle(userId)}
              >
                <img
                  src={profilePic || defautUserImage}
                  alt="icon"
                  onError={(e) => {
                    e.currentTarget.src = defautUserImage;
                  }}
                />
              </div>
              <div
                className={styles["client-name"]}
                onClick={() => isFromDashBoard && handlePopupToggle(userId)}
              >
                {fullName}
              </div>
              {shouldShowUserSeeMore(data, user) && (
                <div
                  className={styles["see-btn"]}
                  onClick={() => toggleSeeMoreForUser(userId)}
                >
                  <span>
                    {seeMoreUsers.includes(userId)
                      ? t("scheduler.agenda.seeLess")
                      : t("scheduler.agenda.seeMore")}
                  </span>
                  <img
                    className={
                      seeMoreUsers.includes(userId)
                        ? styles["rotate-caret-icon"]
                        : ""
                    }
                    src={require("assets/images/caret-587E85.svg").default}
                    alt="caret"
                  />
                </div>
              )}

              {popupOpen === userId && (
                <div className={styles.schedular_popup_daily_view}>
                  <span
                    className={styles.close_btn}
                    onClick={() => handlePopupToggle(userId)}
                  >
                    <img src={crossIcon} alt="close" />
                  </span>
                  <div className={styles.content_wrapper}>
                    <div className={styles.client_img}>
                      <img src={profilePic || defautUserImage} alt="icon" />
                    </div>
                    <Text
                      size="14px"
                      weight="600"
                      color="#587E85"
                      marginTop="6px"
                    >
                      {fullName}
                    </Text>
                    <Text size="12px" weight="500" color="#87928D">
                      {designationNames?.map(
                        (designationName) => designationName,
                      )}
                    </Text>
                    <Text size="12px" weight="500" color="#2A4642">
                      {officeNames?.join(", ")}
                    </Text>
                    <div className={styles.email_number}>
                      <div className={styles.wrap_cont}>
                        <img src={CallIcon} alt="CallIcon" />
                        <Text size="12px" weight="500" color="#587E85">
                          {emailId}
                        </Text>
                      </div>
                      <div className={styles.wrap_cont}>
                        <img src={CallIcon} alt="CallIcon" />
                        <Text size="12px" weight="500" color="#587E85">
                          {contactNumber}
                        </Text>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </th>
          {data.map((_item, i, allData) => {
            const {
              requestedDate,
              appointments,
              leaves,
              schedulerBusySlots,
              schedulerEvents,
              appointmentSlots,
              holidayList,
            } = _item;
            if (!cellRef.current[ui].child[i]) {
              cellRef.current[ui].child[i] = {
                cell: null,
                seeMore: null,
                maxVisibleEvents: 2,
              };
            }

            let allItems = eventsWorkspaceMode
              ? filterEventWorkspaceSchedulerEvents(schedulerEvents)
              : addAllItemsTypes({
                  schedulerEvents,
                  appointments,
                  schedulerBusySlots,
                  appointmentSlots,
                  leaves,
                });
            allItems = eventsWorkspaceMode
              ? filterEventsWorkspaceBySearch(allItems, searchValue)
              : filterEventsBySearch(allItems, user, searchValue);
            let slicedItems = allItems;
            const allValues = cellRef.current[ui].child[i];
            const maxVisibleEvents = viewSettingFilter?.length
              ? allValues.maxVisibleEvents
              : 2;
            const showSeeMore = allItems.length > 2;
            const searchKey = `${userId}_${requestedDate}`;
            const cellOfficeId =
              (schedulerEvents || []).find((event) => event?.officeId)
                ?.officeId ??
              (Array.isArray(apiOffices) && apiOffices.length === 1
                ? apiOffices[0]
                : null);
            const cellDateKey = moment(requestedDate).format("YYYY-MM-DD");
            const showDropPreview =
              eventsWorkspaceMode &&
              isDragging &&
              dragPreviewCell &&
              String(dragPreviewCell.userId) === String(userId) &&
              dragPreviewCell.requestedDate === cellDateKey &&
              draggedEvent?.eventItem;
            const showEmptyCellAdd =
              eventsWorkspaceMode &&
              !bulkSelectMode &&
              !isDragging &&
              allItems.length === 0;
            const singleSeeMoreEnabled = seeMoreOnCalender.includes(searchKey);
            if (dontShowMore && !singleSeeMoreEnabled) {
              slicedItems = allItems.slice(0, maxVisibleEvents);
            }

            const headerClassHighlight = highlightClassWhenEventWillExist({
              cellDate: new Date(requestedDate),
              allData,
              i,
              type: "holiday",
              key: "requestedDate",
              disabledDates,
              styles,
            });

            const bottomClass =
              userData.length - 1 === ui && headerClassHighlight
                ? styles.styles_bottom_border
                : "";
            const mapping = (item, index, hideOrShow = null) => {
              if (eventsWorkspaceMode) {
                return getSchedulerEventsView(
                  item,
                  index,
                  searchKey,
                  requestedDate,
                  fullName,
                  hideOrShow,
                  {
                    requestedDate,
                    userId,
                    officeId: item?.officeId,
                    officeName: item?.officeName,
                    isShift: item?.isShift,
                    user,
                  },
                );
              }
              if (!item?.agendaType) return null;
              const { agendaType } = item;
              switch (agendaType) {
                case constants.agendaType.EVENT: {
                  return getSchedulerEventsView(
                    item,
                    index,
                    searchKey,
                    requestedDate,
                    fullName,
                    hideOrShow,
                    {
                      requestedDate,
                      userId,
                      officeId: item?.officeId,
                      officeName: item?.officeName,
                      isShift: item?.isShift,
                      user,
                    },
                  );
                }
                case constants.agendaType.BUSY_SLOT:
                case constants.agendaType.BLOCKED: {
                  return getSchedulerBusySlotsView(
                    item,
                    index,
                    agendaType === constants.agendaType.BUSY_SLOT,
                    searchKey,
                    requestedDate,
                    fullName,
                    hideOrShow,
                  );
                }
                case constants.agendaType.APPOINTMENT: {
                  return getAppointmentsView(
                    item,
                    index,
                    searchKey,
                    requestedDate,
                    fullName,
                    hideOrShow,
                  );
                }
                case constants.agendaType.LEAVE: {
                  return getLeavesView(
                    item,
                    index,
                    searchKey,
                    requestedDate,
                    fullName,
                    hideOrShow,
                  );
                }
                default: {
                  return null;
                }
              }
            };
            const leaveClassFromDetail = leaveScreenEnabled({
              isfromLeaveDetailScreen,
              isFromLeaveDetail,
              requestedMomentDate: moment(requestedDate),
            });

            return (
              <td
                key={requestedDate}
                className={`schedular-cell-spacing ${
                  leaveClassFromDetail && userId === isFromLeaveDetail?.userID
                    ? leaveClassFromDetail
                    : holidayList?.length > 0
                      ? styles["light-red-bg"]
                      : styles["no-bg-theme"]
                } ${headerClassHighlight} ${bottomClass}`}
                style={showEmptyCellAdd ? { cursor: "pointer" } : undefined}
                ref={(ref) => {
                  cellRef.current[ui].child[i].cell = ref;
                }}
                onClick={
                  showEmptyCellAdd
                    ? () => openCreateEventFromEmptyCell({ requestedDate })
                    : undefined
                }
                onDragOver={
                  eventsWorkspaceMode
                    ? (e) =>
                        handleCellDragOver(e, {
                          requestedDate,
                          userId,
                          officeId: cellOfficeId,
                          user,
                        })
                    : undefined
                }
                onDrop={
                  eventsWorkspaceMode
                    ? (e) =>
                        handleCellDrop(e, {
                          requestedDate,
                          userId,
                          officeId: cellOfficeId,
                          user,
                        })
                    : undefined
                }
              >
                {showEmptyCellAdd ? (
                  <EmptySchedulerCellAdd
                    ariaLabel={t(
                      canAddShift
                        ? "accountOwner.newEventShift"
                        : "accountOwner.newEvent",
                    )}
                    onClick={() =>
                      openCreateEventFromEmptyCell({ requestedDate })
                    }
                  />
                ) : (
                  <>
                    {slicedItems.map((item, index) => mapping(item, index))}
                    {showDropPreview && (
                      <div
                        style={{
                          marginTop: "4px",
                          pointerEvents: "none",
                          border: "2px dashed #C8E364",
                          borderRadius: 4,
                          overflow: "hidden",
                        }}
                      >
                        {getSchedulerEventsView(
                          draggedEvent.eventItem,
                          "drag-preview",
                          searchKey,
                          requestedDate,
                          fullName,
                          { marginBottom: 0 },
                          draggedEvent.sourceContext || {},
                          true,
                        )}
                      </div>
                    )}
                    {allItems.length > maxVisibleEvents &&
                      [allItems[maxVisibleEvents]].map((item, index) =>
                        mapping(item, index, {
                          visibility: "hidden",
                          position: "fixed",
                          top: "-200px",
                        }),
                      )}
                    {allItems.length > maxVisibleEvents &&
                      dontShowMore &&
                      showSeeMore && (
                        <div
                          className={styles["more-event-box"]}
                          ref={(ref) => {
                            cellRef.current[ui].child[i].seeMore = ref;
                          }}
                        >
                          <span
                            className={styles["more-event-btn"]}
                            onClick={() => {
                              toggleSeeMoreOnCalender(searchKey);
                            }}
                          >
                            {seeMoreOnCalender.includes(searchKey)
                              ? t("scheduler.agenda.seeLess")
                              : t("scheduler.agenda.seeMoreWithCount", {
                                  count: allItems.length - maxVisibleEvents,
                                })}
                          </span>
                        </div>
                      )}
                  </>
                )}
              </td>
            );
          })}
        </tr>
      );
    });

    holidayRowJsx = (
      <tr>
        {[{}, ...filteredAgendaFilter].map((date, index, allData) => {
          if (index === 0) {
            return (
              <td
                key={`holiday-${index}`}
                style={isFromDashBoard ? { borderLeft: "none" } : {}}
              ></td>
            );
          }
          const headerClassHighlight = highlightClassWhenEventWillExist({
            cellDate: new Date(date?.requestedDate),
            allData: filteredAgendaFilter,
            i: index - 1,
            type: "holiday",
            key: "requestedDate",
            disabledDates,
            styles,
          });
          const adjustedIndex = index - 1;
          const validIndex =
            adjustedIndex >= 0 && filteredAgendaFilter[adjustedIndex];

          const holidayList = validIndex
            ? filteredAgendaFilter[adjustedIndex].holidayList
            : null;

          if (
            holidayList?.length > 0 &&
            validIndex?.requestedDate === holidayList?.[0]?.date
          ) {
            return (
              <td
                key={`holiday-${index}`}
                className={
                  styles["holiday-cell"] + " p-0 " + headerClassHighlight
                }
              >
                <div className={styles["holiday_title"]}>
                  <img
                    src={HolidayImage}
                    alt="holiday"
                    className="account_owner_image"
                  />
                  <div
                    className={
                      styles.holiday_title_text + " text-wrap text-break"
                    }
                  >
                    {holidayList?.[0]?.title}
                  </div>
                </div>
              </td>
            );
          }
          return (
            <td key={`holiday-${index}`} className={headerClassHighlight}></td>
          );
        })}
      </tr>
    );
  }
  useEffect(() => {
    if (popUpRef.current && hoverKey) {
      const parentTr =
        popUpRef.current.parentElement.parentElement.parentElement.getBoundingClientRect();
      const td =
        popUpRef.current.parentElement.parentElement.getBoundingClientRect();
      if (parentTr.right - td.right <= 430) {
        popUpRef.current.style.left = "-420px";
      }
    }
  }, [hoverKey]);

  const tableColumnCount =
    (isWeekly ? weekData?.length : monthData?.length || 0) + 1;
  const showWeeklyEmptyState = !tableJsx && !isLoading && !isFetching;

  return (
    <div
      className={
        eventsWorkspaceMode
          ? `${styles["events-workspace-weekly-grid"]} table-card-border`
          : "table-card-border "
      }
      style={isFromDashBoard ? { borderLeft: "none" } : {}}
    >
      {(isLoading ||
        isFetching ||
        isFreeStotLoading ||
        isBulkActionLoading ||
        isDragDropLoading ||
        isDuplicateLoading ||
        isAssignLoading ||
        isNotesLoading) && <Loader />}

      <div className={styles["scheduler-table-wrapper"]}>
        <div
          ref={(node) => {
            // Keep original developer ref logic
            if (calendarRef) {
              if (typeof calendarRef === "function") calendarRef(node);
              else calendarRef.current = node;
            }
            // Use my ref for calculation logic
            scrollContainerRef.current = node;
          }}
          className={
            (isFromDashBoard
              ? styles["scheduler-fixed-table-new"]
              : styles["scheduler-fixed-table"]) +
            (showWeeklyEmptyState ? " center_empty" : "")
          }
          style={
            isFromDashBoard
              ? {}
              : {
                  maxHeight: tableHeight,
                  overflowY: "auto",
                }
          }
        >
          <table
            className={`table table-bordered ${styles["schedular-table"]} ${styles["staff-weekly-table"]}`}
            style={
              isFromDashBoard
                ? { borderLeft: "none" }
                : eventsWorkspaceMode
                  ? undefined
                  : { borderTop: "none" }
            }
          >
            <thead className="header_static">
              <tr>
                <th
                  className={`${styles.timesheet_table_common_th} p-0 ${
                    isFromDashBoard ? styles.timesheet_table_dashboard_th : ""
                  }`}
                >
                  <p
                    className={
                      styles.weekly_agenda_header +
                      " " +
                      styles.padding +
                      " " +
                      "m-0"
                    }
                  ></p>
                </th>

                {tableDates}
              </tr>
            </thead>
            <tbody>
              {eventsWorkspaceMode && isWeekly && sortStaffBy && (
                <UnassignedEventsStaffRow
                  t={t}
                  daysData={unassignedStaffDaysData}
                  labelCellClassName={styles.timesheet_table_common_th}
                  labelCellStyle={
                    isFromDashBoard ? { borderLeft: "none" } : undefined
                  }
                  onCellDragOver={handleUnassignedCellDragOver}
                  onCellDrop={handleUnassignedCellDrop}
                  dragPreviewCell={dragPreviewCell}
                  renderDragPreview={(day) => {
                    if (!draggedEvent?.eventItem) return null;
                    const dateStr =
                      day?.dateStr || moment(day?.date).format("YYYY-MM-DD");
                    return (
                      <div
                        style={{
                          marginTop: "4px",
                          pointerEvents: "none",
                          border: "2px dashed #C8E364",
                          borderRadius: 4,
                          overflow: "hidden",
                        }}
                      >
                        {getSchedulerEventsView(
                          draggedEvent.eventItem,
                          "unassigned_drag-preview",
                          `unassigned_preview_${dateStr}`,
                          dateStr,
                          "",
                          { marginBottom: 0 },
                          draggedEvent.sourceContext || {},
                          true,
                        )}
                      </div>
                    );
                  }}
                  renderEventCard={(event, requestedDate) => {
                    const dateStr =
                      serializeSchedulerHistoryDate(requestedDate);
                    const unassignedOfficeName =
                      event?.officeName ||
                      event?.eventEmployeeOfficeName ||
                      event?.officeNameList ||
                      event?.office?.name ||
                      event?.office?.officeName ||
                      null;
                    const unassignedOfficeId =
                      event?.officeId ??
                      event?.office?.id ??
                      event?.office?.officeId ??
                      null;
                    return getSchedulerEventsView(
                      event,
                      `unassigned_${event.id}`,
                      `unassigned_${dateStr}`,
                      dateStr,
                      "",
                      null,
                      {
                        requestedDate: dateStr,
                        officeId: unassignedOfficeId,
                        officeName: unassignedOfficeName,
                        isShift: event?.isShift,
                        isUnassigned: true,
                      },
                    );
                  }}
                />
              )}
              {holidayRowJsx}
              {tableJsx ? (
                tableJsx
              ) : showWeeklyEmptyState ? (
                <tr>
                  <td
                    colSpan={tableColumnCount}
                    className={styles.weekly_empty_state_cell}
                  >
                    <Empty
                      Message={t(
                        eventsWorkspaceMode
                          ? "scheduler.eventsEmptyMessage"
                          : "scheduler.noEventsFound",
                      )}
                    />
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
      {renderMultipleDuplicatesFlyout(onDuplicateEvent, t)}
      {renderAssignUsersModals()}
      {eventsWorkspaceMode && (
        <>
          <AddNotesModal
            isAddNotesModal={isAddNotesModal}
            setIsAddNotesModal={setIsAddNotesModal}
            updateList={updateDayNoteList}
            setIsLoading={setIsNotesLoading}
            getDetailsOwnerIfStaff={selectedOwnerId}
          />
          <EditNotesModal
            isEditNotesModal={isEditNotesModal}
            setIsEditNotesModal={setIsEditNotesModal}
            addNotesModelShow={addNotesModelShow}
            setdeleteConfirmation={setdeleteConfirmation}
          />
          <DeleteNotes
            isDeleteEventModalOpen={deleteConfirmation.visible}
            setIsDeleteEventModalOpen={setdeleteConfirmation}
            deleteNotesConfirm={deleteNotesConfirm}
            updateList={updateDayNoteList}
          />
          {renderSimpleDeleteConfirmModal()}
        </>
      )}
      <SelectOfficeForUserModal
        isOpen={isOfficeSelectModalOpen}
        ownerId={selectedOwnerId}
        userId={pendingOfficeDrop?.dropContext?.targetUserId}
        isShift={pendingOfficeDrop?.isShift ?? true}
        onClose={handleOfficeModalClose}
        onConfirm={handleOfficeModalConfirm}
      />
      {eventsWorkspaceMode && (
        <QuickEditModal
          isOpen={isQuickEditOpen}
          onClose={closeQuickEdit}
          onSave={saveQuickEdit}
          ownerId={selectedOwnerId || currentUserId}
          userId={quickEditContext?.userId}
          initialOfficeId={quickEditContext?.initialOfficeId}
          initialOfficeName={quickEditContext?.initialOfficeName}
          initialDate={quickEditContext?.initialDate}
          initialStartTime={quickEditContext?.initialStartTime}
          initialEndTime={quickEditContext?.initialEndTime}
          isSaving={isQuickEditSaving}
        />
      )}
      {editModalConfirmation && pendingDragUpdate && (
        <EditOptionsModal
          isOpen={editModalConfirmation}
          closeStepOneModal={setEditModalConfirmation}
          loader={isDragDropLoading}
          eventKey={{
            eventOrShift: t(
              `accountOwner.${
                pendingDragUpdate.eventData?.isShift ? "shift" : "event"
              }Tab`,
            ).toLowerCase(),
          }}
          eventOrShiftTab={pendingDragUpdate.eventData?.isShift || false}
          busySlots={false}
          repeatedOptionChanged={pendingDragUpdate.anyChangedForDate || false}
          handleConfirm={async (value) => {
            setIsDragDropLoading(true);
            try {
              const newDateTime = buildDateTimeForDrop(
                pendingDragUpdate.eventData,
                pendingDragUpdate.dropContext.targetDate,
              );
              await performEventUpdate(
                pendingDragUpdate.eventData,
                newDateTime,
                pendingDragUpdate.dropContext,
                value,
                pendingDragUpdate.originalRequestedDate,
              );
            } catch {
            } finally {
              setEditModalConfirmation(false);
              setPendingDragUpdate(null);
              setIsDragDropLoading(false);
              setIsDragging(false);
              setDraggedEvent(null);
              setDragPreviewCell(null);
            }
          }}
        />
      )}
    </div>
  );
}

export default withTranslation()(StaffAvailabilityWeeklyView);
